import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import ReactPlayer from 'react-player';
import { Col, Row } from "reactstrap";
import PlayArrowIcon from '@mui/icons-material/Stop';
import PauseIcon from '@mui/icons-material/Pause';
import PushPinIcon from '@mui/icons-material/PushPin';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import StopIcon from '@mui/icons-material/StopCircle';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { MultiVideoPlayerProps, VideoSegment } from '../../../utils/types';
import ProgressScale from '../../video-player/progressScale';
import { CircularProgress } from "@mui/material";
import showToast from '../../../utils/toast';
import { debounce } from 'lodash';
import { colors } from '../../../constants/colors';
import { ArrowBack } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveIndex } from '../../../redux/reducers/service-reducer';
import { Stage, Layer, Rect, Line, Text, Circle, Group } from "react-konva";
import Konva from "konva";
import { ClockFiveIcon } from '../../../utils/ClockFiveIcon';
import { RefreshCircleIcon } from '../../../utils/RefreshCircleIcon';
import { RatioIcon } from '../../../utils/rationIcon';
import dayjs from 'dayjs';
import { useMediaQuery, useTheme } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AssessmentIcon from '@mui/icons-material/Assessment';
import VideoChart from '../../video-player/videoChart';
// import "./cctvViewPlayer.css";
import { RootState } from '../../../redux/store';
import { CLASS_COLORS } from '../../../utils/colors';
import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import SmartToyIcon from '@mui/icons-material/AutoAwesome';
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { getDeviceTtcPetLine, getExportData, getExportDataTtcPet } from '../../../redux/actions/service-action';
import { formatDateTimeRange } from '../../../utils/methods';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

// One colour per TTC region so adjacent zones stay tellable apart; the old
// overlay painted every zone the same red.
const TTC_ZONE_COLORS = [
  { stroke: "#00E5FF", fill: "rgba(0,229,255,0.16)" },
  { stroke: "#76FF03", fill: "rgba(118,255,3,0.16)" },
  { stroke: "#FF4081", fill: "rgba(255,64,129,0.16)" },
  { stroke: "#FFAB40", fill: "rgba(255,171,64,0.16)" },
  { stroke: "#B388FF", fill: "rgba(179,136,255,0.16)" },
];

const MultiVideoPlayerCctv: React.FC<MultiVideoPlayerProps> = ({
  videoSegments,
  timeFilterData,
  playVideoTime,
  onTimeChange = () => { },
  isSDCard = true,
  playingStatus,
  lineData,
  previousApiLinesData,
  rawApiLines,
  zoneData,
  pedZoneData,
  drawingMode,
  setDrawingMode,
  lines = [],
  setLines = () => { },
  ttcCountData,
  petCountData
}) => {
  const [currentTime, setCurrentTime] = useState<number>(playVideoTime ?? 0);
  useEffect(() => {
    if (playVideoTime !== undefined && playVideoTime !== null) {
      setCurrentTime(playVideoTime);
      updateVideoSources(playVideoTime, true);
    }
  }, [playVideoTime]);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [muted, setMuted] = useState<boolean>(true);
  const [videoUrls, setVideoUrls] = useState<Record<string, string>>({});
  const [lastProgrammaticUpdate, setLastProgrammaticUpdate] = useState<number>(0);
  const [targetTime, setTargetTime] = useState<number | null>(null);
  const [isJumping, setIsJumping] = useState<boolean>(false);
  const [videoLoading, setVideoLoading] = useState<Record<string, boolean>>({});
  const [videoErrors, setVideoErrors] = useState<Record<string, string | null>>({});
  const [selectedCamera, setSelectedCamera] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const videoContainerRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const [isHovered, setIsHovered] = useState(false);
  const [videoRotation, setVideoRotation] = useState<{ [key: string]: number }>({});
  const [activeTimeFilters, setActiveTimeFilters] = useState<string[]>([]);
  const [videoLoader, setVideoLoader] = useState<boolean>(false);
  const videoLoaderTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const currentSegmentRef = useRef<string>("");
  const [exportLoading, setExportLoading] = useState(false);
  const [displayScale, setDisplayScale] = useState<any>({
    renderW: 0,
    renderH: 0,
    offsetX: 0,
    offsetY: 0,
    scaleX: 1,
    scaleY: 1
  });
  const view = useSelector((state: any) => state.ui?.view || "Dashboard");
  const [isSegmentSwitching, setIsSegmentSwitching] = useState(false);
  const [cameraOrder, setCameraOrder] = useState<number[]>(
    Array.isArray(videoSegments) ? videoSegments.map((_, index) => index) : []
  );
  const [playbackRate, setPlaybackRate] = useState(1);
  const [showSpeedOptions, setShowSpeedOptions] = useState(false);
  const [showTimeOptions, setShowTimeOptions] = useState(false);
  const videoPlaySec = [0.5, 1, 1.5, 2, 3];
  const videoLastData = ["Last 5 Min", "Last 15 Min", "Last 30 Min", "Last 1 Hour", "Last 3 Hours", "Last 6 Hours", "Last 12 Hours"];
  const { activeCarDetails } = useSelector((state: RootState) => state.service);
  const videoSectionRef = useRef(null);
  const playerRefs = useRef<{ [key: string]: ReactPlayer | null }>({});
  const [recordingState, setRecordingState] = useState<{ [key: string]: boolean }>({});
  const [recordedUrls, setRecordedUrls] = useState<{ [key: string]: string | null }>({});
  const recorderRefs = useRef<{ [key: string]: MediaRecorder | null }>({});
  const chunksRefs = useRef<{ [key: string]: Blob[] }>({});
  const [recordingTimes, setRecordingTimes] = useState<{ [key: string]: number }>({});
  const intervalRefs = useRef<{ [key: string]: NodeJS.Timeout | null }>({});
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const bufferTimeouts = useRef<Record<string, NodeJS.Timeout | null>>({});
  const [isScrolled, setIsScrolled] = useState(false);
  const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });
  const [openExportModal, setOpenExportModal] = useState(false);
  const [selectedExportType, setSelectedExportType] = useState("AI Data");
  const [ttcPetLineData, setTtcPetData] = useState<any>(null);
  const isDrawingMode = drawingMode !== null;
  const [isDrawing, setIsDrawing] = useState(false);
  const [currentLine, setCurrentLine] = useState<number[]>([]);
  const [distance, setDistance] = useState("");
  const [lineName, setLineName] = useState("");
  const [showDistanceInput, setShowDistanceInput] = useState(false);
  const [showVideoChart, setShowVideoChart] = useState(false);
  const FPS = 25;
  const [objects, setObjects] = useState<any[]>([]);
  const [tracks, setTracks] = useState<any[]>([]);
  const stageRef = useRef<Konva.Stage | null>(null);
  const jsonCache = useRef<any>({});
  const currentJson = useRef<any>(null);
  const lastSegment = useRef<number | null>(null);
  const trackHistory = useRef<Record<string | number, number[]>>({});
  const { selectedDate } = useSelector((state: any) => state.service);
  const prefetchedSegments = useRef<Set<string>>(new Set());
  const rafRef = useRef<number | null>(null);
  const lastRenderedFrame = useRef<number>(-1);
  const [trajectoryLines, setTrajectoryLines] = useState<any[]>([]);
  const [bufferedUntil, setBufferedUntil] = useState<number>(0);
  type FeatureKey = "ttc" | "pet" | "videoAnalytics" | "trajectory" | "lineZone";
  const [aiMode, setAiMode] = useState(false);

  const [features, setFeatures] = useState<Record<FeatureKey, boolean>>({
    ttc: false,
    pet: false,
    videoAnalytics: false,
    trajectory: false,
    lineZone: false,
  });

  const featuresRef = useRef(features);
  useEffect(() => { featuresRef.current = features; }, [features]);

  const canvasSizeRef = useRef(canvasSize);
  useEffect(() => { canvasSizeRef.current = canvasSize; }, [canvasSize]);

  const getTtcData = async () => {
    const tunnelUrl = activeCarDetails?.raw?.tunnel_info?.[0];
    try {
      const res: any = await getDeviceTtcPetLine(tunnelUrl);
      if (res) {
        setTtcPetData(res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const toggleFeature = async (key: FeatureKey) => {
    const enable = !features[key];
    const resetFeatures = {
      ttc: false,
      pet: false,
      videoAnalytics: false,
      trajectory: false,
      lineZone: false,
    };
    setFeatures({
      ...resetFeatures,
      [key]: enable,
    });
    if (key === "ttc" && enable) {
      await getTtcData();
    }
  };

  const getSloatFromSeconds = useCallback((seconds: number): string => {
    const hh = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const mm = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    return `${hh}${mm}00`;
  }, []);

  const sloatTime = useMemo(() => getSloatFromSeconds(currentTime), [currentTime, getSloatFromSeconds]);

  useEffect(() => {
    playingStatus(isPlaying);
  }, [isPlaying]);

  useEffect(() => {
    jsonCache.current = {};
    currentJson.current = null;
    lastSegment.current = null;
    trackHistory.current = {};
    lastRenderedFrame.current = -1;
  }, [sloatTime]);

  // ==================== INITIAL VIDEO STATES ====================
  const initializeVideoStates = useMemo(() => {
    const initialUrls: Record<string, string> = {};
    const initialLoading: Record<string, boolean> = {};
    const initialErrors: Record<string, string | null> = {};
    videoSegments.forEach((_, index) => {
      const cameraKey = `video-${index}`;
      initialUrls[cameraKey] = '';
      initialLoading[cameraKey] = false;
      initialErrors[cameraKey] = null;
    });
    return { initialUrls, initialLoading, initialErrors };
  }, [videoSegments]);

  useEffect(() => {
    setVideoUrls(initializeVideoStates.initialUrls);
    setVideoLoading(initializeVideoStates.initialLoading);
    setVideoErrors(initializeVideoStates.initialErrors);
  }, [initializeVideoStates]);

  // ==================== TIME HELPERS ====================
  const timeToSeconds = useCallback((timeStr: string): number => {
    if (!timeStr) return 0;
    const parts = timeStr.split(":").map(Number);
    if (parts.length !== 3) return 0;
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
  }, []);

  const findVideoSegment = useCallback(
    (time: number, cameraIndex: number) => {
      const segments = videoSegments?.[cameraIndex] || [];
      for (const segment of segments) {
        const start = segment.start;
        const end = segment.end;
        if (time >= start && time < end) {
          return segment;
        }
      }
      return undefined;
    },
    [videoSegments]
  );

  const hasSegmentAtTime = useCallback((time: number) => {
    return videoSegments.some((_, index) => findVideoSegment(time, index));
  }, [videoSegments, findVideoSegment]);

  const findNearestValidTime = useCallback((time: number, direction: 'forward' | 'backward' = 'forward') => {
    let nearest = time;
    const step = direction === 'forward' ? 1 : -1;
    while (!hasSegmentAtTime(nearest) && nearest >= 0 && nearest < 86400) {
      nearest += step;
    }
    return nearest;
  }, [hasSegmentAtTime]);

  const prefetchSegment = useCallback((url: string) => {
    if (!url) return;
    if (prefetchedSegments.current.has(url)) {
      return;
    }
    prefetchedSegments.current.add(url);
    fetch(url, {
      method: "GET",
      cache: "force-cache",
    }).catch(() => { });
  }, []);

  const handleVideoLoader = useCallback(() => {
    const now = Date.now();
    if (now - lastProgrammaticUpdate < 500) return;
    setVideoLoader(true);
    if (videoLoaderTimeoutRef.current) {
      clearTimeout(videoLoaderTimeoutRef.current);
    }
    videoLoaderTimeoutRef.current = setTimeout(() => {
      setVideoLoader(false);
      videoLoaderTimeoutRef.current = null;
    }, 900);
  }, [lastProgrammaticUpdate]);

  // ==================== VIDEO SOURCES ====================
  const updateVideoSources = useCallback(
    (time: number, isProgrammatic = false) => {
      const formattedDate = dayjs(selectedDate).format("YYYYMMDD");
      const cleanTime = Math.floor(time);
      const formattedTime = [
        Math.floor(cleanTime / 3600),
        Math.floor((cleanTime % 3600) / 60),
        cleanTime % 60,
      ]
        .map((v) => String(v).padStart(2, "0"))
        .join("");
      const clickedDateTime = `${formattedDate}T${formattedTime}`;
      const newUrls: Record<string, string> = {};
      videoSegments.forEach((_, index) => {
        const cameraKey = `video-${index}`;
        const segment = findVideoSegment(time, index);
        if (!segment) {
          newUrls[cameraKey] = "";
          return;
        }
        const segmentKey = segment.specific_file_url;
        // User clicked timeline
        if (isProgrammatic) {
          currentSegmentRef.current = segmentKey;
          newUrls[cameraKey] =
            `${segment.specific_file_url}?start=${clickedDateTime}`;
          return;
        }
        // Auto playback
        if (currentSegmentRef.current !== segmentKey) {
          setVideoLoading(prev => ({
            ...prev,
            [cameraKey]: true,
          }));
          currentSegmentRef.current = segmentKey;
          const segmentStartSeconds = segment.start;
          const segmentTime = [
            Math.floor(segmentStartSeconds / 3600),
            Math.floor((segmentStartSeconds % 3600) / 60),
            segmentStartSeconds % 60,
          ]
            .map((v) => String(v).padStart(2, "0"))
            .join("");
          const segmentStartDateTime =
            `${formattedDate}T${segmentTime}`;
          newUrls[cameraKey] =
            `${segment.specific_file_url}?start=${segmentStartDateTime}`;
          // console.log(
          //   "AUTO SEGMENT LOAD",
          //   segmentStartDateTime
          // );
        } else {
          // Same segment -> keep old URL
          newUrls[cameraKey] = videoUrls[cameraKey];
        }
      });
      setVideoUrls((prev) => {
        const changed =
          JSON.stringify(prev) !== JSON.stringify(newUrls);
        return changed ? newUrls : prev;
      });
      if (isProgrammatic) {
        setLastProgrammaticUpdate(Date.now());
      }
    },
    [
      selectedDate,
      videoSegments,
      findVideoSegment,
      videoUrls,
    ]
  );

  const debouncedHandleTimelineChange = useMemo(() =>
    debounce(() => {
      setIsScrolled(true);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setIsScrolled(false);
      }, 5000);
    }, 500),
    []
  );

  const handleTimelineChange = useCallback(
    (seconds: number) => {
      debouncedHandleTimelineChange()
      handleVideoLoader();
      const now = Date.now();
      if (now - lastProgrammaticUpdate < 500 || (targetTime !== null && Math.abs(seconds - targetTime) > 1)) {
        return;
      }
      setCurrentTime(seconds);
      setTargetTime(null);
      updateVideoSources(seconds, true);
      onTimeChange(seconds);

    },
    [lastProgrammaticUpdate, targetTime, updateVideoSources, onTimeChange, handleVideoLoader]
  );

  const jumpToTime = useCallback(
    (startTime: string) => {
      if (isJumping) return;
      setIsJumping(true);
      const seconds = timeToSeconds(startTime);
      setTargetTime(seconds);
      setCurrentTime(seconds);
      updateVideoSources(seconds, true);
      setIsPlaying(false);
      onTimeChange(seconds);
      setTimeout(() => setIsJumping(false), 100);
    },
    [isJumping, timeToSeconds, updateVideoSources, onTimeChange]
  );

  useEffect(() => {
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  const togglePlayPause = useCallback(() => {
    setIsPlaying(prev => !prev);
  }, []);

  const toggleFullscreen = useCallback(async () => {
    if (!containerRef.current) return;
    if (!document.fullscreenElement) {
      try { await containerRef.current.requestFullscreen(); } catch (err) { console.error(err); }
    } else {
      try { await document.exitFullscreen(); } catch (err) { console.error(err); }
    }
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) setSelectedCamera(null);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  const handlePinClick = (index: number) => {
    const newCameraOrder = [...cameraOrder];
    const currentIndex = newCameraOrder.indexOf(index);
    if (currentIndex === -1 || cameraOrder.length <= 1) return;
    newCameraOrder.splice(currentIndex, 1);
    newCameraOrder.push(index);
    setCameraOrder(newCameraOrder);
  };

  const videoCount = useMemo(() => videoSegments?.length || 1, [videoSegments]);
  const isOdd = useMemo(() => videoCount % 2 !== 0, [videoCount]);
  const isSingle = useMemo(() => videoCount === 1, [videoCount]);

  const handleRotateVideo = (cameraKey: string) => {
    setVideoRotation(prev => ({ ...prev, [cameraKey]: (prev[cameraKey] || 0) + 90 }));
  };

  const startRecording = (cameraKey: string) => {
    const videoElement: any = playerRefs.current[cameraKey]?.getInternalPlayer() as HTMLVideoElement;
    const rotation = videoRotation[cameraKey] || 0;
    if (!videoElement) { showToast("Could not access the internal video element.", "e"); return; }
    if (videoElement.readyState < 3) { showToast("Please start playing the video first before recording.", "e"); return; }
    if (typeof videoElement.captureStream !== "function") { showToast("Video recording is not supported by your browser.", "e"); return; }
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    const width = videoElement.videoWidth;
    const height = videoElement.videoHeight;
    if (rotation === 90 || rotation === 270) { canvas.width = height; canvas.height = width; }
    else { canvas.width = width; canvas.height = height; }
    const watermark = new Image();
    watermark.src = "/watermark.png";
    // const drawFrame = () => {
    //   ctx.save();
    //   ctx.clearRect(0, 0, canvas.width, canvas.height);
    //   switch (rotation) {
    //     case 90: ctx.translate(canvas.width, 0); ctx.rotate(Math.PI / 2); break;
    //     case 180: ctx.translate(canvas.width, canvas.height); ctx.rotate(Math.PI); break;
    //     case 270: ctx.translate(0, canvas.height); ctx.rotate((3 * Math.PI) / 2); break;
    //   }
    //   ctx.drawImage(videoElement, 0, 0, width, height);
    //   if (watermark.complete) {
    //     const aspectRatio = watermark.width / watermark.height;
    //     const maxLogoWidth = Math.min(300, canvas.width * 0.18);
    //     const logoWidth = Math.max(80, maxLogoWidth);
    //     const logoHeight = logoWidth / aspectRatio;
    //     ctx.globalAlpha = 0.7;
    //     ctx.drawImage(watermark, canvas.width - logoWidth - 10, canvas.height - logoHeight - 10, logoWidth, logoHeight);
    //     ctx.globalAlpha = 1;
    //   }
    //   ctx.restore();
    //   requestAnimationFrame(drawFrame);
    // };

    const drawFrame = () => {
      ctx.save();
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      switch (rotation) {
        case 90: ctx.translate(canvas.width, 0); ctx.rotate(Math.PI / 2); break;
        case 180: ctx.translate(canvas.width, canvas.height); ctx.rotate(Math.PI); break;
        case 270: ctx.translate(0, canvas.height); ctx.rotate((3 * Math.PI) / 2); break;
      }
      ctx.drawImage(videoElement, 0, 0, width, height);

      // NEW: draw TTC/PET Line & Line/Zone overlays into the recording if enabled
      const liveFeatures = featuresRef.current;
      const liveCanvasSize = canvasSizeRef.current;
      if (
        (liveFeatures.ttc || liveFeatures.lineZone) &&
        stageRef.current &&
        liveCanvasSize.width &&
        liveCanvasSize.height
      ) {
        try {
          const overlayCanvas = stageRef.current.toCanvas({ pixelRatio: 1 });
          ctx.drawImage(
            overlayCanvas,
            0, 0, liveCanvasSize.width, liveCanvasSize.height,
            0, 0, width, height
          );
        } catch (err) {
          console.error("Overlay capture error", err);
        }
      }

      ctx.restore();
      if (watermark.complete) {
        const aspectRatio = watermark.width / watermark.height;
        const maxLogoWidth = Math.min(300, canvas.width * 0.18);
        const logoWidth = Math.max(80, maxLogoWidth);
        const logoHeight = logoWidth / aspectRatio;
        ctx.globalAlpha = 0.7;
        ctx.drawImage(watermark, canvas.width - logoWidth - 10, canvas.height - logoHeight - 10, logoWidth, logoHeight);
        ctx.globalAlpha = 1;
      }
      requestAnimationFrame(drawFrame);
    };
    drawFrame();
    const stream = canvas.captureStream(30);
    // const recorder = new MediaRecorder(stream);
    const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp9')
      ? 'video/webm;codecs=vp9'
      : 'video/webm;codecs=vp8';

    const recorder = new MediaRecorder(stream, {
      mimeType,
      videoBitsPerSecond: 8_000_000,
    });

    recorderRefs.current[cameraKey] = recorder;
    chunksRefs.current[cameraKey] = [];
    recorder.ondataavailable = (e) => { if (e.data.size > 0) chunksRefs.current[cameraKey].push(e.data); };
    recorder.onstop = () => {
      const blob = new Blob(chunksRefs.current[cameraKey], { type: 'video/webm' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none'; a.href = url; a.download = `recording-${cameraKey}.webm`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      if (intervalRefs.current[cameraKey]) { clearInterval(intervalRefs.current[cameraKey]!); intervalRefs.current[cameraKey] = null; }
      setRecordingTimes((prev) => ({ ...prev, [cameraKey]: 0 }));
      setRecordedUrls((prev) => { const updated = { ...prev }; delete updated[cameraKey]; return updated; });
    };
    recorder.start();
    setRecordingState((prev) => ({ ...prev, [cameraKey]: true }));
    setRecordingTimes((prev) => ({ ...prev, [cameraKey]: 0 }));
    intervalRefs.current[cameraKey] = setInterval(() => {
      setRecordingTimes((prev) => ({ ...prev, [cameraKey]: (prev[cameraKey] || 0) + 1 }));
    }, 1000);
  };

  const stopRecording = (cameraKey: string) => {
    const recorder = recorderRefs.current[cameraKey];
    if (recorder) {
      recorder.stop();
      setRecordingState((prev) => ({ ...prev, [cameraKey]: false }));
      if (intervalRefs.current[cameraKey]) { clearInterval(intervalRefs.current[cameraKey]!); intervalRefs.current[cameraKey] = null; }
    }
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

  const dispatch = useDispatch();
  const { activeIndex } = useSelector((state: any) => state.service);
  const onClickPlayBack = () => { dispatch(setActiveIndex(0)); };

  // const updateScale = useCallback((container: HTMLDivElement, video: HTMLVideoElement) => {
  //   if (!container || !video || !video.videoWidth || !video.videoHeight) return;
  //   const containerW = container.clientWidth;
  //   const containerH = container.clientHeight;
  //   const videoW = video.videoWidth;
  //   const videoH = video.videoHeight;
  //   const videoAspect = videoW / videoH;
  //   const containerAspect = containerW / containerH;
  //   let renderW = containerW, renderH = containerH, offsetX = 0, offsetY = 0;
  //   if (containerAspect > videoAspect) {
  //     renderH = containerH; renderW = renderH * videoAspect; offsetX = (containerW - renderW) / 2;
  //   } else {
  //     renderW = containerW; renderH = renderW / videoAspect; offsetY = (containerH - renderH) / 2;
  //   }
  //   setDisplayScale({
  //     renderW,
  //     renderH,
  //     offsetX,
  //     offsetY,
  //     scaleX: renderW / videoW,
  //     scaleY: renderH / videoH,
  //   });
  //   setCanvasSize({ width: containerW, height: containerH });
  // }, []);

  const scaleWatched = useRef(new WeakSet<HTMLVideoElement>());
  // Overlays (zones, lines) are drawn through displayScale. It must change
  // together with the Stage size, also while the video is still loading
  // (videoWidth is 0 after every new segment): until the real size is known,
  // assume the 16:9 frame the overlays are configured in.
  const updateScale = useCallback((container: HTMLDivElement, video?: HTMLVideoElement | null) => {
    if (!container) return;
    const containerW = container.clientWidth;
    const containerH = container.clientHeight;
    if (!containerW || !containerH) return;
    const videoW = video?.videoWidth || 1920;
    const videoH = video?.videoHeight || 1080;
    const videoAspect = videoW / videoH;
    const containerAspect = containerW / containerH;
    let renderW, renderH;
    if (containerAspect > videoAspect) {
      renderW = containerW;
      renderH = renderW / videoAspect;
    } else {
      renderH = containerH;
      renderW = renderH * videoAspect;
    }
    const offsetX = (containerW - renderW) / 2;
    const offsetY = (containerH - renderH) / 2;
    setDisplayScale({
      renderW,
      renderH,
      offsetX,
      offsetY,
      scaleX: renderW / videoW,
      scaleY: renderH / videoH,
    });
    setCanvasSize({ width: containerW, height: containerH });
  }, []);

  const loadSegmentJson = useCallback(async (_segmentIndex: number) => {
    const tunnelUrl = activeCarDetails?.raw?.tunnel_info?.[0];
    if (!features?.videoAnalytics) return;
    if (!tunnelUrl) return;
    if (!isPlaying) return;
    setObjects([]);
    setTracks([]);
    const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
    if (jsonCache.current[sloatTime]) {
      currentJson.current = jsonCache.current[sloatTime];
      return;
    }
    try {
      const url = `https://papli-desktop-3.taildfe778.ts.net/recordings_json/${formattedDate}/${sloatTime}/ai_results.json`;
      const res = await fetch(url);
      if (!res.ok) {
        console.warn(`Failed to load JSON: ${res.status}`);
        return;
      }
      const data = await res.json();
      const frameMap: any = {};
      (data.per_second || []).forEach((item: any) => {
        frameMap[item.frame] = item;
      });
      jsonCache.current[sloatTime] = {
        ...data,
        frameMap
      };
      currentJson.current = jsonCache.current[sloatTime];
    } catch (err) {
      console.error("JSON LOAD ERROR", err);
    }
  }, [sloatTime, selectedDate]);

  // ==================== STEP 2: renderDetections (FIXED) ====================
  const renderDetections = useCallback((seconds: number) => {
    if (!currentJson.current) {
      setObjects([]);
      setTracks([]);
      return;
    }
    const fps = currentJson.current.fps || 25;
    const OFFSET = 1;
    const currentFrame = Math.round(seconds * fps) + OFFSET;
    const frameData = currentJson.current.frameMap?.[currentFrame];
    if (!frameData) {
      return;
    }
    const detections = [
      ...(frameData.people || []),
      ...(frameData.vehicles || [])
    ];
    const DETECTION_WIDTH = 1280;
    const DETECTION_HEIGHT = 720;
    const scaleX = canvasSize.width / DETECTION_WIDTH;
    const scaleY = canvasSize.height / DETECTION_HEIGHT;
    const formatted: any[] = [];
    const newTracks: any[] = [];
    detections.forEach((obj: any) => {
      const [x1, y1, x2, y2] = obj.bbox;
      const scaledX1 = x1 * scaleX;
      const scaledY1 = y1 * scaleY;
      const scaledX2 = x2 * scaleX;
      const scaledY2 = y2 * scaleY;
      const centerX = (scaledX1 + scaledX2) / 2;
      const centerY = (scaledY1 + scaledY2) / 2;
      formatted.push({
        id: obj.id,
        label: obj.class,
        x: scaledX1,
        y: scaledY1,
        width: scaledX2 - scaledX1,
        height: scaledY2 - scaledY1,
        centerX,
        centerY,
      });
      if (!trackHistory.current[obj.id]) {
        trackHistory.current[obj.id] = [];
      }
      const history = trackHistory.current[obj.id];
      if (history.length >= 2) {
        const lastX = history[history.length - 2];
        const lastY = history[history.length - 1];
        const dist = Math.hypot(centerX - lastX, centerY - lastY);
        if (dist > 100) {
          trackHistory.current[obj.id] = [];
        }
      }
      trackHistory.current[obj.id].push(centerX, centerY);
      if (trackHistory.current[obj.id].length > 100) {
        trackHistory.current[obj.id].splice(0, 2);
      }
      newTracks.push({
        id: obj.id,
        points: trackHistory.current[obj.id],
      });
    });
    setObjects(formatted);
    setTracks(newTracks);
  }, [canvasSize]);

  // ==================== STEP 3: startDetectionLoop ====================

  const isAnyVideoLoading = Object.values(videoLoading).some(Boolean);

  // useEffect(() => {
  //   if (!isPlaying || isAnyVideoLoading) return;
  //   const interval = setInterval(() => {
  //     setCurrentTime((prev) => {
  //       const next = prev + 1;
  //       onTimeChange(next);
  //       return next;
  //     });
  //   }, 1000 / playbackRate);
  //   return () => clearInterval(interval);
  // }, [isPlaying, playbackRate, isAnyVideoLoading]);

  // useEffect(() => {
  //   if (!isPlaying || isAnyVideoLoading || isSegmentSwitching) return;
  //   const interval = setInterval(() => {
  //     setCurrentTime((prev) => {
  //       const next = prev + 1;
  //       return next;
  //     });
  //   }, 1000);
  //   return () => clearInterval(interval);
  // }, [
  //   isPlaying,
  //   isAnyVideoLoading,
  //   isSegmentSwitching,
  // ]);

  // useEffect(() => {
  //   if (!isPlaying || isAnyVideoLoading || isSegmentSwitching) return;
  //   const interval = setInterval(() => {
  //     setCurrentTime((prev) => {
  //       const next = prev + 1;
  //       return next;
  //     });
  //   }, 1000);
  //   return () => clearInterval(interval);
  // }, [
  //   isPlaying,
  //   isAnyVideoLoading,
  //   isSegmentSwitching,
  // ]);

  useEffect(() => {
    if (!isPlaying || isAnyVideoLoading || isSegmentSwitching) return;
    const interval = setInterval(() => {
      setCurrentTime((prev) => {
        return prev + playbackRate;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [
    isPlaying,
    playbackRate,
    isAnyVideoLoading,
    isSegmentSwitching,
  ]);

  useEffect(() => {
    const segment = findVideoSegment(currentTime, 0);
    if (!segment) return;
    const segmentKey = segment.specific_file_url;
    if (
      currentSegmentRef.current &&
      currentSegmentRef.current !== segmentKey
    ) {
      // console.log(
      //   "SEGMENT CHANGED",
      //   currentSegmentRef.current,
      //   "=>",
      //   segmentKey
      // );
      updateVideoSources(currentTime, false);
    }
  }, [
    currentTime,
    findVideoSegment,
    updateVideoSources,
  ]);

  useEffect(() => {
    const run = async () => {
      if (isPlaying) return;
      await loadSegmentJson(0);
      const player = playerRefs.current['video-0'];
      const video: any = player?.getInternalPlayer();
      renderDetections(video?.currentTime ?? currentTime);
    };
    run();
  }, [currentTime, isPlaying]);

  useEffect(() => {
    const cameraKey = "video-0";
    const container = videoContainerRefs.current[cameraKey];
    if (!container) return;
    const tryUpdateScale = () => {
      const player = playerRefs.current[cameraKey];
      const video: any = player?.getInternalPlayer();
      setTimeout(() => updateScale(container, video), 10);
    };
    const resizeObserver = new ResizeObserver(() => tryUpdateScale());
    resizeObserver.observe(container);
    setTimeout(tryUpdateScale, 100);
    return () => resizeObserver.disconnect();
  }, [updateScale]);

  // Turning an overlay on does not resize anything, so none of the resize
  // listeners fire and the overlay is drawn against a stale scale -- which is
  // why it only appeared after going fullscreen. Re-measure on toggle.
  useEffect(() => {
    const cameraKey = "video-0";
    const container = videoContainerRefs.current[cameraKey];
    const player = playerRefs.current[cameraKey];
    const video: any = player?.getInternalPlayer();
    if (!container) return;
    const t = setTimeout(() => updateScale(container, video), 50);
    return () => clearTimeout(t);
  }, [features, updateScale]);

  useEffect(() => {
    const handleResizeOrChange = () => {
      const cameraKey = "video-0";
      const container = videoContainerRefs.current[cameraKey];
      const player = playerRefs.current[cameraKey];
      const video: any = player?.getInternalPlayer();
      if (container) {
        setTimeout(() => updateScale(container, video), 50);
      }
    };
    window.addEventListener('resize', handleResizeOrChange);
    document.addEventListener('fullscreenchange', handleResizeOrChange);
    return () => {
      window.removeEventListener('resize', handleResizeOrChange);
      document.removeEventListener('fullscreenchange', handleResizeOrChange);
    };
  }, [updateScale]);

  useEffect(() => {
    const cameraKey = "video-0";
    const container = videoContainerRefs.current[cameraKey];
    if (!container) return;
    const observer = new ResizeObserver(() => {
      const player = playerRefs.current[cameraKey];
      const video = player?.getInternalPlayer() as HTMLVideoElement;
      setTimeout(() => updateScale(container, video), 50);
    });
    observer.observe(container);
    const handleFullscreenOrRotate = () => {
      const player = playerRefs.current[cameraKey];
      const video = player?.getInternalPlayer() as HTMLVideoElement;
      setTimeout(() => updateScale(container, video), 80);
    };
    window.addEventListener('resize', handleFullscreenOrRotate);
    document.addEventListener('fullscreenchange', handleFullscreenOrRotate);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleFullscreenOrRotate);
      document.removeEventListener('fullscreenchange', handleFullscreenOrRotate);
    };
  }, [updateScale]);

  const getLabelWidth = (label: string) => {
    switch (label) {
      case "person": return 50;
      case "car": return 32;
      case "truck": return 42;
      case "bus": return 32;
      case "motorcycle": return 80;
      default: return 50;
    }
  };

  const getNextName = (items: any[] = [], type: "line" | "region") => {
    const prefix = type === "line" ? "line" : "zone";
    const safeItems = Array.isArray(items) ? items : [];
    const numbers = safeItems
      .filter(item => item?.type === type)
      .map(item => {
        const name = type === "line" ? item?.line_name : item?.region_name;
        const match = name?.match(/\d+/);
        return match ? parseInt(match[0]) : 0;
      });
    const max = numbers.length > 0 ? Math.max(...numbers) : 0;
    return `${prefix}${max + 1}`;
  };

  const createLinePayload = (line: number[], distance: number) => {
    const { renderW, renderH, offsetX, offsetY } = displayScale;
    const sourceWidth = 1920;
    const sourceHeight = 1080;
    return {
      type: "line",
      line_name: lineName || getNextName(rawApiLines?.items, "line"),
      lx1: Number(
        (((line[0] - offsetX) / renderW) * sourceWidth).toFixed(2)
      ),
      ly1: Number(
        (((line[1] - offsetY) / renderH) * sourceHeight).toFixed(2)
      ),
      lx2: Number(
        (((line[2] - offsetX) / renderW) * sourceWidth).toFixed(2)
      ),
      ly2: Number(
        (((line[3] - offsetY) / renderH) * sourceHeight).toFixed(2)
      ),
      dist_m: distance,
      sourceWidth,
      sourceHeight,
    };
  };

  // const createZonePayload = (lines: number[][], distance: number) => {
  //   const { renderW, renderH, offsetX, offsetY } = displayScale;
  //   const sourceWidth = 1920;
  //   const sourceHeight = 1080;
  //   const convertX = (x: number) =>
  //     Number((((x - offsetX) / renderW) * sourceWidth).toFixed(2));
  //   const convertY = (y: number) =>
  //     Number((((y - offsetY) / renderH) * sourceHeight).toFixed(2));
  //   return {
  //     type: "zone_occupancy",
  //     region_name: lineName || getNextName(rawApiLines?.items, "region"),
  //     dist_m: distance,
  //     l1x1: convertX(lines[0][0]),
  //     l1y1: convertY(lines[0][1]),
  //     l1x2: convertX(lines[0][2]),
  //     l1y2: convertY(lines[0][3]),
  //     l2x1: convertX(lines[1][0]),
  //     l2y1: convertY(lines[1][1]),
  //     l2x2: convertX(lines[1][2]),
  //     l2y2: convertY(lines[1][3]),
  //     sourceWidth,
  //     sourceHeight,
  //   };
  // };

  const createZonePayload = (lines: number[][], distance: number) => {
    const { renderW, renderH, offsetX, offsetY } = displayScale;
    const sourceWidth = 1920;
    const sourceHeight = 1080;

    const convertX = (x: number) =>
      Number((((x - offsetX) / renderW) * sourceWidth).toFixed(2));
    const convertY = (y: number) =>
      Number((((y - offsetY) / renderH) * sourceHeight).toFixed(2));

    const [l1x1, l1y1, l1x2, l1y2] = lines[0];
    const [l2x1, l2y1, l2x2, l2y2] = lines[1];

    // Order: line1 start -> line1 end -> line2 end -> line2 start
    // (traces a closed, non-crossing quadrilateral)
    const points = [
      { x: convertX(l1x1), y: convertY(l1y1) },
      { x: convertX(l1x2), y: convertY(l1y2) },
      { x: convertX(l2x2), y: convertY(l2y2) },
      { x: convertX(l2x1), y: convertY(l2y1) },
    ];

    return {
      type: "zone_occupancy",
      region_name: lineName || getNextName(rawApiLines?.items, "region"),
      dist_m: distance,
      points,
      sourceWidth,
      sourceHeight,
    };
  };

  useEffect(() => {
    if (drawingMode === "line" && lines.length === 1) {
      setShowDistanceInput(true);
    } else if (drawingMode === "zone" && lines.length === 2) {
      setShowDistanceInput(true);
    } else {
      setShowDistanceInput(false);
    }
  }, [lines, drawingMode]);

  const seekBySeconds = useCallback((seconds: number) => {
    let newTime = currentTime + seconds;
    newTime = Math.max(0, Math.min(86400, newTime));
    if (!hasSegmentAtTime(newTime)) {
      newTime = findNearestValidTime(
        newTime,
        seconds > 0 ? "forward" : "backward"
      );
    }
    setCurrentTime(newTime);
    onTimeChange(newTime);
    updateVideoSources(newTime, true);
  }, [
    currentTime,
    hasSegmentAtTime,
    findNearestValidTime,
    updateVideoSources,
    onTimeChange,
  ]);
  const fiveSecBack = useCallback(() => seekBySeconds(-5), [seekBySeconds]);
  const fiveSecForward = useCallback(() => seekBySeconds(5), [seekBySeconds]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dynamicMarginLeft = isMobile ? '23%' : (view === 'Map' ? '40%' : '40%');
  const getFilterSeconds = (label: string): number => {
    const map: Record<string, number> = {
      "Last 5 Min": 5 * 60, "Last 15 Min": 15 * 60, "Last 30 Min": 30 * 60,
      "Last 1 Hour": 60 * 60, "Last 3 Hours": 3 * 60 * 60,
      "Last 6 Hours": 6 * 60 * 60, "Last 12 Hours": 12 * 60 * 60,
    };
    return map[label] ?? 0;
  };
  const filteredVideoSegments = useMemo(() => {
    if (activeTimeFilters.length === 0) return videoSegments;
    const maxDuration = Math.max(...activeTimeFilters.map(getFilterSeconds));
    const windowStart = Math.max(0, currentTime - maxDuration);
    const windowEnd = currentTime;
    return videoSegments?.map(cameraSegments =>
      cameraSegments
        .filter((seg: VideoSegment) => seg.end > windowStart && seg.start < windowEnd)
        .map((seg: VideoSegment) => ({
          ...seg,
          start: Math.max(seg.start, windowStart),
          end: Math.min(seg.end, windowEnd),
        }))
    );
  }, [activeTimeFilters, currentTime, videoSegments]);

  // ==================== PROCESS TRAJECTORIES ====================
  const processedTrajectories = useMemo(() => {
    if (!lineData?.length || canvasSize.width === 0) return [];
    const tracks = new Map<number, { points: number[], class: string, id: number }>();
    lineData?.forEach((frame: any) => {
      const people = frame.people || [];
      people.forEach((person: any) => {
        const id = person.id;
        const cls = person.class || 'person';
        const [x, y] = person.center || [0, 0];
        if (!tracks.has(id)) {
          tracks.set(id, { points: [], class: cls, id });
        }
        const track = tracks.get(id)!;
        const scaledX = (x / 1280) * canvasSize.width;
        const scaledY = (y / 720) * canvasSize.height;
        track.points.push(scaledX, scaledY);
      });
    });
    return Array.from(tracks.values());
  }, [lineData, canvasSize]);

  useEffect(() => {
    setTrajectoryLines(processedTrajectories);
  }, [processedTrajectories]);

  const optimizeTrajectoryPoints = (
    points: number[],
    options?: {
      step?: number;
      maxPoints?: number;
    }
  ) => {
    const step = options?.step || 4;
    const maxPoints = options?.maxPoints || 80;
    if (!points || points.length < 2) return [];
    const result: number[] = [];
    for (let i = 0; i < points.length; i += step * 2) {
      result.push(points[i], points[i + 1]);
    }
    if (result.length > maxPoints * 2) {
      return result.slice(result.length - maxPoints * 2);
    }
    return result;
  };

  const TrajectoryDots = React.memo(({ track, isPlaying }: any) => {
    const color = CLASS_COLORS[track.class] || CLASS_COLORS.default;
    const optimizedPoints = React.useMemo(() => {
      return optimizeTrajectoryPoints(track.points, {
        step: isPlaying ? 6 : 3,
        maxPoints: isPlaying ? 50 : 100,
      });
    }, [track.points, isPlaying]);
    if (optimizedPoints.length < 2) return null;

    return (
      <>
        {optimizedPoints.map((_, i) => {
          if (i % 2 !== 0) return null;
          const x = optimizedPoints[i];
          const y = optimizedPoints[i + 1];
          return (
            <Circle
              key={`${track.id}-${i}`}
              x={x}
              y={y}
              radius={isPlaying ? 2 : 1.3}
              fill={color}
              opacity={isPlaying ? 0.7 : 1}
              listening={false}
            />
          );
        })}
      </>
    );
  });

  const AISwitch = styled(Switch)(() => ({
    width: 34,
    height: 18,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(14px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          background: "linear-gradient(135deg, #6a00ff, #3b00ff)",
          opacity: 1,
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: 14,
      height: 14,
      backgroundColor: "#fff",
    },
    "& .MuiSwitch-track": {
      borderRadius: 20,
      backgroundColor: "#333",
      opacity: 1,
    },
  }));

  const getTotalCount = (name: string) => {
    const counts = zoneData?.class_counts_by_region?.[name];
    if (!counts) return "0";
    const total = Object.values(counts).reduce(
      (sum: number, value: any) => sum + Number(value),
      0
    );
    return total.toLocaleString();
  };

  // Latest people count per zone from the ped-zone-data API. Response is an
  // array of { zone, sum }; map zone -> sum.
  const zoneLiveCounts = React.useMemo(() => {
    const result: Record<string, number> = {};
    (pedZoneData || []).forEach((item: any) => {
      if (!item || item.zone == null) return;
      result[item.zone] = item.sum ?? 0;
    });
    return result;
  }, [pedZoneData]);

  // ==================== RENDER ====================
  const getExportDataInExcel = async () => {
    setExportLoading(true);
    const selectedDeviceDate = formatDateTimeRange(selectedDate);
    try {
      const payload = {
        statDate:
          selectedDeviceDate?.start_datetime?.replace(" ", "T") + ":00",
        endDate:
          selectedDeviceDate?.end_datetime?.replace(" ", "T") + ":59",
        deviceId: activeCarDetails?.raw?.uuid,
        exportType: selectedExportType,
      };
      const res: any =
        selectedExportType === "PETData" ||
          selectedExportType === "TTCData"
          ? await getExportDataTtcPet(payload)
          : await getExportData(payload);
      if (!res) {
        showToast("Something went wrong", "e");
        return;
      }
      // All export types (AI / TTC / PET) return Excel (.xlsx) from the backend.
      const isExcel = true;
      const fileData = res?.data || res;
      const blob = new Blob([fileData], {
        type: isExcel
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "text/csv;charset=utf-8;",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${selectedExportType.replace(/\s+/g, "_")}_${Date.now()}.${
          isExcel ? "xlsx" : "csv"
        }`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setOpenExportModal(false);
    } catch (error) {
      console.error("Export API Error:", error);
      showToast("Export failed", "e");
    } finally {
      setExportLoading(false);
    }
  };

  useEffect(() => {
    if (!videoSegments?.length) return;
    const firstSegment = videoSegments?.[0]?.[0];
    if (!firstSegment) return;
    setCurrentTime(firstSegment.start);
    updateVideoSources(firstSegment.start);
  }, [videoSegments]);

  useEffect(() => {
    if (
      features?.lineZone &&
      rawApiLines?.items?.length > 0
    ) {
      const cameraKey = "video-0";
      const container = videoContainerRefs.current[cameraKey];
      const player = playerRefs.current[cameraKey];
      const video = player?.getInternalPlayer() as HTMLVideoElement;
      if (container && video) {
        updateScale(container, video);
      }
      setCanvasSize(prev => ({
        ...prev
      }));
    }
  }, [
    rawApiLines,
    features?.lineZone,
    updateScale
  ]);

  const zoneCounts = React.useMemo(() => {
    const ttcCounts: Record<string, number> = {};
    const petCounts: Record<string, number> = {};
    // TTC
    (ttcCountData?.events || []).forEach((e: any) => {
      ttcCounts[e.Direction] = (ttcCounts[e.Direction] || 0) + 1;
    });
    // PET
    (petCountData?.events || []).forEach((e: any) => {
      petCounts[e.Direction] = (petCounts[e.Direction] || 0) + 1;
    });
    return { ttcCounts, petCounts };
  }, [ttcCountData, petCountData]);
  return (
    <Row>
      {activeIndex === 1 && (
        <div
          onClick={onClickPlayBack}
          style={{
            position: 'absolute', zIndex: 1, gap: 4, margin: "5px 20px", padding: 5,
            backgroundColor: colors.modalBackground, color: colors.white, fontWeight: 'bold',
            border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex',
            alignItems: 'center', width: "120px"
          }}
        >
          <ArrowBack style={{ marginLeft: 5, color: colors.orange }} />
          Playback
        </div>
      )}
      {videoSegments?.length > 0 ? (
        <Col xs={12} style={{ padding: "0px" }}>
          <div ref={containerRef} className="video-player-container">
            <div ref={videoSectionRef} className={`video-grid ${isSingle ? 'single' : ''} ${isOdd ? 'odd' : 'even'}`}>
              {cameraOrder?.map((index: any, displayIndex: any) => {
                const cameraKey = `video-${index}`;
                if (selectedCamera !== null && selectedCamera !== index) return null;
                const segment = findVideoSegment(currentTime, index);
                return (
                  <div
                    key={cameraKey}
                    ref={el => (videoContainerRefs.current[cameraKey] = el)}
                    className="video-wrapper"
                    style={{ position: 'relative' }}
                  >
                    {segment && !isSDCard ? (
                      <>
                        <div
                          className="player-container"
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                          style={{ marginTop: "-17px", background: "#333", cursor: "pointer" }}
                          onClick={togglePlayPause}
                        >
                          <ReactPlayer
                            ref={(el) => (playerRefs.current[cameraKey] = el)}
                            url={videoUrls[cameraKey]}
                            playing={isPlaying}
                            playbackRate={playbackRate}
                            muted={displayIndex !== cameraOrder.length - 1 || muted}
                            width="100%"
                            height="100%"
                            controls={false}
                            playsinline
                            config={{
                              file: {
                                forceHLS: true,
                                hlsOptions: {
                                  enableWorker: true,
                                  lowLatencyMode: false,
                                  maxBufferLength: 300,
                                  maxMaxBufferLength: 600,
                                  backBufferLength: 120,
                                  maxBufferSize: 60 * 1000 * 1000, // 60MB
                                }
                              },
                            }}
                            onBuffer={() => {
                              bufferTimeouts.current[cameraKey] = setTimeout(() => {
                                setVideoLoading(prev => ({
                                  ...prev,
                                  [cameraKey]: true,
                                }));
                              }, 1500);
                            }}

                            onReady={() => {
                              // Re-measure once the video knows its real size; nothing
                              // resizes then, so no resize listener would fire.
                              const v = playerRefs.current[cameraKey]?.getInternalPlayer() as HTMLVideoElement;
                              if (!v || scaleWatched.current.has(v)) return;
                              scaleWatched.current.add(v);
                              v.addEventListener("resize", () => {
                                const c = videoContainerRefs.current[cameraKey];
                                if (c) updateScale(c, v);
                              });
                            }}
                            onBufferEnd={() => {
                              const c = videoContainerRefs.current[cameraKey];
                              const v = playerRefs.current[cameraKey]?.getInternalPlayer() as HTMLVideoElement;
                              if (c) updateScale(c, v);
                              const timeout = bufferTimeouts.current[cameraKey];
                              if (timeout) {
                                clearTimeout(timeout);
                              }
                              setVideoLoading(prev => ({
                                ...prev,
                                [cameraKey]: false,
                              }));
                            }}
                            onError={(e) => {
                              console.error("Video Error", cameraKey, e);
                            }}
                            onProgress={({ playedSeconds }) => {
                              const segment = findVideoSegment(currentTime, index);
                              if (!segment) return;
                              const duration = segment.end - segment.start;
                              if (duration - playedSeconds < 5) {
                                const segments = videoSegments[index] || [];
                                const currentSegmentIndex = segments.findIndex(
                                  s => s.specific_file_url === segment.specific_file_url
                                );
                                const nextSegment = segments[currentSegmentIndex + 1];
                                if (nextSegment) {
                                  prefetchSegment(nextSegment.specific_file_url);
                                }
                              }
                            }}
                          />
                          <img
                            src="/watermark.png"
                            alt="watermark"
                            style={{
                              position: 'absolute', bottom: '10px', right: '10px',
                              width: '150px', opacity: 0.7, zIndex: 999, pointerEvents: 'none',
                            }}
                          />
                          <Stage
                            width={canvasSize.width}
                            height={canvasSize.height}
                            style={{ position: "absolute", top: 0, left: 0, pointerEvents: isDrawingMode ? "auto" : "none" }}
                            ref={stageRef}
                            onMouseDown={(e: any) => {
                              if (!drawingMode) return;
                              if (drawingMode === "line" && lines.length >= 1) return;
                              if (drawingMode === "zone" && lines.length >= 2) return;
                              const pos = e.target.getStage().getPointerPosition();
                              if (!pos) return;
                              setCurrentLine([pos.x, pos.y]);
                              setIsDrawing(true);
                            }}
                            onMouseMove={(e: any) => {
                              if (!isDrawing || !drawingMode) return;
                              const pos = e.target.getStage().getPointerPosition();
                              if (!pos) return;
                              setCurrentLine(prev => [prev[0], prev[1], pos.x, pos.y]);
                            }}
                            onMouseUp={() => {
                              if (!drawingMode) return;
                              setIsDrawing(false);
                              if (currentLine.length === 4) {
                                setLines(prev => [...prev, currentLine]);
                              }
                              setCurrentLine([]);
                            }}
                          >
                            <Layer>
                              {!isPlaying && (
                                <>
                                  {features?.trajectory && (
                                    <>
                                      {processedTrajectories?.map((track) => (
                                        <TrajectoryDots
                                          key={track.id}
                                          track={track}
                                          isPlaying={isPlaying}
                                        />
                                      ))}
                                    </>
                                  )}
                                </>
                              )}

                              {tracks?.map(track =>
                                track.points.length > 4 ? (
                                  <Line
                                    key={`track-${track.id}`}
                                    points={track.points}
                                    stroke="#58e6b3"
                                    strokeWidth={2}
                                    tension={0.4}
                                    lineCap="round"
                                    lineJoin="round"
                                  />
                                ) : null
                              )}

                              {/* {lines?.map((line, i) => (
                                <Line key={`draw-${i}`} points={line} stroke="blue" strokeWidth={3} />
                              ))} */}

                              {drawingMode === "zone" && lines.length === 2 ? (
                                <Line
                                  points={[
                                    lines[0][0], lines[0][1],
                                    lines[0][2], lines[0][3],
                                    lines[1][2], lines[1][3],
                                    lines[1][0], lines[1][1],
                                  ]}
                                  closed
                                  stroke="yellow"
                                  strokeWidth={3}
                                  fill="rgba(255,255,0,0.15)"
                                />
                              ) : (
                                lines?.map((line, i) => (
                                  <Line key={`draw-${i}`} points={line} stroke="yellow" strokeWidth={3} />
                                ))
                              )}

                              {/* {features?.ttc && (
                                <>
                                  {ttcPetLineData?.items?.map((item: any, i: number) => {
                                    const sourceWidth = 1920;
                                    const sourceHeight = 1080;
                                    const scaleX = canvasSize.width / sourceWidth;
                                    const scaleY = canvasSize.height / sourceHeight;
                                    const l1x1 = item.l1x1 * scaleX;
                                    const l1y1 = item.l1y1 * scaleY;
                                    const l1x2 = item.l1x2 * scaleX;
                                    const l1y2 = item.l1y2 * scaleY;
                                    const l2x1 = item.l2x1 * scaleX;
                                    const l2y1 = item.l2y1 * scaleY;
                                    const l2x2 = item.l2x2 * scaleX;
                                    const l2y2 = item.l2y2 * scaleY;
                                    const polygonPoints = [
                                      l1x1,
                                      l1y1,
                                      l1x2,
                                      l1y2,
                                      l2x2,
                                      l2y2,
                                      l2x1,
                                      l2y1,
                                    ];
                                    const centerX =
                                      (l1x1 + l1x2 + l2x1 + l2x2) / 4;
                                    const centerY =
                                      (l1y1 + l1y2 + l2y1 + l2y2) / 4;
                                    return (
                                      <React.Fragment key={`ttc-zone-${i}`}>
                                        <Line
                                          points={polygonPoints}
                                          closed
                                          fill="rgba(255,0,0,0.15)"
                                          stroke="#ff0000"
                                          strokeWidth={3}
                                        />
                                        <Text
                                          text={item.region_name}
                                          x={centerX - 60}
                                          y={centerY - 10}
                                          width={120}
                                          align="center"
                                          fontSize={16}
                                          fill="#ff0000"
                                          fontStyle="bold"
                                        />
                                        <Text
                                          text={`TTC Count : ${ttcCountData ?? 0}`}
                                          x={20}
                                          y={20}
                                          fontSize={15}
                                          fill="#00ff00"
                                          fontStyle="bold"
                                        />
                                      </React.Fragment>
                                    );
                                  })}
                                  {ttcPetLineData?.lane_boundaries?.map(
                                    (lane: any, i: number) => {
                                      const sourceWidth = 1920;
                                      const sourceHeight = 1080;
                                      const scaleX = canvasSize.width / sourceWidth;
                                      const scaleY = canvasSize.height / sourceHeight;
                                      const x1 = lane.pt1[0] * scaleX;
                                      const y1 = lane.pt1[1] * scaleY;
                                      const x2 = lane.pt2[0] * scaleX;
                                      const y2 = lane.pt2[1] * scaleY;
                                      return (
                                        <>
                                          <Line
                                            key={`ttc-lane-${i}`}
                                            points={[x1, y1, x2, y2]}
                                            stroke="#FFA500"
                                            strokeWidth={3}
                                          />

                                          <Text
                                            text={`PET Count : ${petCountData?.total ?? 0}`}
                                            x={20}
                                            y={55}
                                            fontSize={15}
                                            fill="#ff9800"
                                            fontStyle="bold"
                                          />
                                        </>
                                      );
                                    }
                                  )}
                                </>
                              )} */}

                              {features?.ttc && (
                                <>
                                  {(() => {
                                    const { renderW, renderH, offsetX, offsetY } = displayScale;
                                    // Config coords are authored in 1920x1080 space. The video is
                                    // letterboxed inside the stage, so map through the same
                                    // renderW/offsetX the Line & Zone overlay uses -- scaling by
                                    // canvasSize alone puts the zones off the road.
                                    const toX = (v: number, sw: number) =>
                                      offsetX + (v / sw) * renderW;
                                    const toY = (v: number, sh: number) =>
                                      offsetY + (v / sh) * renderH;

                                    const laneBoundaries = ttcPetLineData?.lane_boundaries ?? [];
                                    // Boards that draw in their track space say so in coord_space
                                    // (P1: "1280x720 (track space on P1)") instead of per-item
                                    // sourceWidth; assuming 1920 there shrank every zone to 2/3,
                                    // squeezed toward the top-left.
                                    const space = /(\d+)\s*x\s*(\d+)/.exec(String(ttcPetLineData?.coord_space || ""));
                                    const cfgW = Number(ttcPetLineData?.sourceWidth) || (space ? Number(space[1]) : 1920);
                                    const cfgH = Number(ttcPetLineData?.sourceHeight) || (space ? Number(space[2]) : 1080);

                                    const regions = (ttcPetLineData?.items ?? []).filter(
                                      (item: any) => item?.type === "region"
                                    );
                                    // People-count zones (e.g. bus_stand) live in the same
                                    // config as zone_occupancy items.
                                    const pedZones = (ttcPetLineData?.items ?? []).filter(
                                      (item: any) =>
                                        item?.type === "zone_occupancy" &&
                                        Array.isArray(item.points) &&
                                        item.points.length >= 3
                                    );

                                    return (
                                      <>
                                        {regions.map((item: any, i: number) => {
                                          const sourceWidth = item.sourceWidth || cfgW;
                                          const sourceHeight = item.sourceHeight || cfgH;

                                          const l1x1 = toX(item.l1x1, sourceWidth);
                                          const l1y1 = toY(item.l1y1, sourceHeight);
                                          const l1x2 = toX(item.l1x2, sourceWidth);
                                          const l1y2 = toY(item.l1y2, sourceHeight);
                                          const l2x1 = toX(item.l2x1, sourceWidth);
                                          const l2y1 = toY(item.l2y1, sourceHeight);
                                          const l2x2 = toX(item.l2x2, sourceWidth);
                                          const l2y2 = toY(item.l2y2, sourceHeight);

                                          const polygonPoints = [
                                            l1x1, l1y1, l1x2, l1y2, l2x2, l2y2, l2x1, l2y1,
                                          ];
                                          const centerX = (l1x1 + l1x2 + l2x1 + l2x2) / 4;
                                          const centerY = (l1y1 + l1y2 + l2y1 + l2y2) / 4;

                                          const color = TTC_ZONE_COLORS[i % TTC_ZONE_COLORS.length];

                                          const dist =
                                            item.dist_m != null ? `${item.dist_m}m` : "";
                                          const label = [
                                            item.region_name,
                                            dist ? `(${dist})` : "",
                                          ]
                                            .filter(Boolean)
                                            .join(" ");
                                          const counts = "";

                                          const labelW = Math.max(150, label.length * 8);
                                          const labelH = counts ? 36 : 20;

                                          return (
                                            <React.Fragment key={`ttc-zone-${item.region_name}-${i}`}>
                                              <Line
                                                points={polygonPoints}
                                                closed
                                                fill={color.fill}
                                                stroke={color.stroke}
                                                strokeWidth={2}
                                              />
                                              <Rect
                                                x={centerX - labelW / 2}
                                                y={centerY - labelH / 2}
                                                width={labelW}
                                                height={labelH}
                                                fill="rgba(0,0,0,0.65)"
                                                cornerRadius={3}
                                              />
                                              <Text
                                                text={label}
                                                x={centerX - labelW / 2}
                                                y={centerY - labelH / 2 + 4}
                                                width={labelW}
                                                align="center"
                                                fontSize={13}
                                                fill={color.stroke}
                                                fontStyle="bold"
                                              />
                                              {counts && (
                                                <Text
                                                  text={counts}
                                                  x={centerX - labelW / 2}
                                                  y={centerY - labelH / 2 + 20}
                                                  width={labelW}
                                                  align="center"
                                                  fontSize={12}
                                                  fill="#ffffff"
                                                />
                                              )}
                                            </React.Fragment>
                                          );
                                        })}

                                        {pedZones.map((item: any, i: number) => {
                                          const sw = item.sourceWidth || cfgW;
                                          const sh = item.sourceHeight || cfgH;
                                          const pts = item.points.flatMap((pt: any) => [
                                            toX(pt.x, sw),
                                            toY(pt.y, sh),
                                          ]);
                                          const cx =
                                            item.points.reduce((a: number, pt: any) => a + toX(pt.x, sw), 0) /
                                            item.points.length;
                                          const cy =
                                            item.points.reduce((a: number, pt: any) => a + toY(pt.y, sh), 0) /
                                            item.points.length;
                                          // The people count is not wired up for these zones yet, so
                                          // the label would always read ": 0". Show the name alone.
                                          const text = `${item.region_name}`;
                                          const w = Math.max(150, text.length * 8);
                                          return (
                                            <React.Fragment key={`ped-zone-${item.region_name}-${i}`}>
                                              <Line
                                                points={pts}
                                                closed
                                                fill="rgba(5,102,253,0.18)"
                                                stroke="#0566FD"
                                                strokeWidth={2}
                                              />
                                              <Rect
                                                x={cx - w / 2}
                                                y={cy - 10}
                                                width={w}
                                                height={20}
                                                fill="rgba(0,0,0,0.65)"
                                                cornerRadius={3}
                                              />
                                              <Text
                                                text={text}
                                                x={cx - w / 2}
                                                y={cy - 6}
                                                width={w}
                                                align="center"
                                                fontSize={13}
                                                fill="#ffffff"
                                                fontStyle="bold"
                                              />
                                            </React.Fragment>
                                          );
                                        })}

                                        {laneBoundaries.map((lane: any, i: number) => {
                                          const sourceWidth = cfgW;
                                          const sourceHeight = cfgH;

                                          return (
                                            <Line
                                              key={`ttc-lane-${i}`}
                                              points={[
                                                toX(lane.pt1[0], sourceWidth),
                                                toY(lane.pt1[1], sourceHeight),
                                                toX(lane.pt2[0], sourceWidth),
                                                toY(lane.pt2[1], sourceHeight),
                                              ]}
                                              stroke="#FFD54F"
                                              strokeWidth={2}
                                              dash={[8, 6]}
                                            />
                                          );
                                        })}
                                      </>
                                    );
                                  })()}
                                </>
                              )}


                              {features?.lineZone && rawApiLines?.items?.length > 0 && (
                                <>
                                  {rawApiLines?.items?.map((item: any, i: number) => {
                                    const { renderW, renderH, offsetX, offsetY } = displayScale;
                                    const sourceWidth = item.sourceWidth || 1920;
                                    const sourceHeight = item.sourceHeight || 1080;
                                    if (item.type === "line") {
                                      const x1 =
                                        (item.lx1 / sourceWidth) * renderW +
                                        offsetX;

                                      const y1 =
                                        (item.ly1 / sourceHeight) * renderH +
                                        offsetY;

                                      const x2 =
                                        (item.lx2 / sourceWidth) * renderW +
                                        offsetX;

                                      const y2 =
                                        (item.ly2 / sourceHeight) * renderH +
                                        offsetY;
                                      const centerX = (x1 + x2) / 2;
                                      const centerY = (y1 + y2) / 2;
                                      const angle = (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI;
                                      return (
                                        <React.Fragment key={`line-${i}`}>
                                          <Line
                                            points={[x1, y1, x2, y2]}
                                            stroke="#0566FD80"
                                            strokeWidth={18}
                                          //lineCap="round"
                                          //lineJoin="round"
                                          />
                                          <Group
                                            x={centerX}
                                            y={centerY}
                                            rotation={angle}
                                          >
                                            <Text
                                              text={item.line_name}
                                              fontSize={14}
                                              fill="#ffffff"
                                              width={180}
                                              align="center"
                                              offsetX={80}
                                              offsetY={8}
                                              fontStyle="bold"
                                              shadowColor="black"
                                              shadowBlur={4}
                                              shadowOpacity={0.8}
                                              shadowOffset={{ x: 1, y: 1 }}
                                            />
                                          </Group>
                                        </React.Fragment>
                                      );
                                    }
                                    // if (item.type === "zone_occupancy") {
                                    //   const sourceWidth = item.sourceWidth || 1920;
                                    //   const sourceHeight = item.sourceHeight || 1080;

                                    //   const l1x1 =
                                    //     (item.l1x1 / sourceWidth) * renderW +
                                    //     offsetX;

                                    //   const l1y1 =
                                    //     (item.l1y1 / sourceHeight) * renderH +
                                    //     offsetY;

                                    //   const l1x2 =
                                    //     (item.l1x2 / sourceWidth) * renderW +
                                    //     offsetX;

                                    //   const l1y2 =
                                    //     (item.l1y2 / sourceHeight) * renderH +
                                    //     offsetY;

                                    //   const l2x1 =
                                    //     (item.l2x1 / sourceWidth) * renderW +
                                    //     offsetX;

                                    //   const l2y1 =
                                    //     (item.l2y1 / sourceHeight) * renderH +
                                    //     offsetY;

                                    //   const l2x2 =
                                    //     (item.l2x2 / sourceWidth) * renderW +
                                    //     offsetX;

                                    //   const l2y2 =
                                    //     (item.l2y2 / sourceHeight) * renderH +
                                    //     offsetY;
                                    //   const polygonPoints = [
                                    //     l1x1,
                                    //     l1y1,
                                    //     l1x2,
                                    //     l1y2,
                                    //     l2x2,
                                    //     l2y2,
                                    //     l2x1,
                                    //     l2y1,
                                    //   ];
                                    //   const centerX = (l1x1 + l1x2 + l2x1 + l2x2) / 4;
                                    //   const centerY = (l1y1 + l1y2 + l2y1 + l2y2) / 4;
                                    //   const angle = (Math.atan2(l1y2 - l1y1, l1x2 - l1x1) * 180) / Math.PI;
                                    //   return (
                                    //     <React.Fragment key={`region-${i}`}>
                                    //       <Line
                                    //         points={polygonPoints}
                                    //         closed
                                    //         fill="rgba(5,102,253,0.18)"
                                    //         stroke="#0566FD"
                                    //         strokeWidth={2}
                                    //       />
                                    //       <Group
                                    //         x={centerX}
                                    //         y={centerY}
                                    //         rotation={angle}
                                    //       >
                                    //         <Text
                                    //           text={`${item.region_name} : ${getTotalCount(
                                    //             item.region_name
                                    //           )}`}
                                    //           fontSize={16}
                                    //           fill="#ffffff"
                                    //           width={180}
                                    //           align="center"
                                    //           offsetX={90}
                                    //           offsetY={8}
                                    //           fontStyle="bold"
                                    //           shadowColor="black"
                                    //           shadowBlur={4}
                                    //           shadowOpacity={0.8}
                                    //           shadowOffset={{ x: 1, y: 1 }}
                                    //         />
                                    //       </Group>
                                    //     </React.Fragment>
                                    //   );
                                    // }
                                    if (item.type === "zone_occupancy") {
                                      const sourceWidth = item.sourceWidth || 1920;
                                      const sourceHeight = item.sourceHeight || 1080;

                                      const toX = (x: number) => (x / sourceWidth) * renderW + offsetX;
                                      const toY = (y: number) => (y / sourceHeight) * renderH + offsetY;

                                      const polygonPoints = item.points.flatMap((p: any) => [toX(p.x), toY(p.y)]);

                                      const centerX =
                                        item.points.reduce((sum: number, p: any) => sum + toX(p.x), 0) / item.points.length;
                                      const centerY =
                                        item.points.reduce((sum: number, p: any) => sum + toY(p.y), 0) / item.points.length;

                                      const angle =
                                        (Math.atan2(
                                          toY(item.points[1].y) - toY(item.points[0].y),
                                          toX(item.points[1].x) - toX(item.points[0].x)
                                        ) * 180) / Math.PI;

                                      return (
                                        <React.Fragment key={`region-${i}`}>
                                          <Line
                                            points={polygonPoints}
                                            closed
                                            fill="rgba(5,102,253,0.18)"
                                            stroke="#0566FD"
                                            strokeWidth={2}
                                          />
                                          <Group x={centerX} y={centerY} rotation={angle}>
                                            <Text
                                              text={item.region_name}
                                              fontSize={16}
                                              fill="#ffffff"
                                              width={180}
                                              align="center"
                                              offsetX={90}
                                              offsetY={8}
                                              fontStyle="bold"
                                              shadowColor="black"
                                              shadowBlur={4}
                                              shadowOpacity={0.8}
                                              shadowOffset={{ x: 1, y: 1 }}
                                            />
                                          </Group>
                                        </React.Fragment>
                                      );
                                    }
                                    return null;
                                  })}
                                </>
                              )}

                              {currentLine?.length === 4 && (
                                <Line points={currentLine} stroke="red" strokeWidth={3} dash={[5, 5]} />
                              )}

                              {objects?.map(obj => {
                                const labelWidth = getLabelWidth(obj.label);
                                const labelY = obj.centerY - 30;
                                return (
                                  <React.Fragment key={`obj-${obj.id}`}>
                                    <Line
                                      points={[obj.centerX, obj.centerY, obj.centerX, labelY + 20]}
                                      stroke="#58e6b3"
                                      strokeWidth={2}
                                    />
                                    <Rect
                                      x={obj.x} y={obj.y}
                                      width={obj.width} height={obj.height}
                                      stroke="yellow" strokeWidth={1}
                                    />
                                    <Text
                                      x={obj.centerX - labelWidth / 2 + 6}
                                      y={labelY + 5}
                                      text={String(obj.id)}
                                      fill="yellow"
                                      fontSize={16}
                                    />
                                  </React.Fragment>
                                );
                              })}
                            </Layer>
                          </Stage>
                          {showDistanceInput && (
                            <div style={{ position: "absolute", top: 100, right: 10, background: "white", padding: 3, zIndex: 1000, borderRadius: 6 }}>
                              <input
                                type="text"
                                placeholder="Enter Line/Zone Name"
                                value={lineName}
                                onChange={(e) => setLineName(e.target.value)}
                                style={{ marginBottom: "0px", border: "1px solid #333", color: "#333", borderRadius: "10px", fontSize: "12px", padding: "0px 10px" }}
                              />
                              <br />
                              <input
                                type="number"
                                placeholder="Enter distance"
                                value={distance}
                                onChange={(e) => setDistance(e.target.value)}
                                style={{ marginBottom: "0px", border: "1px solid #333", color: "#333", borderRadius: "10px", fontSize: "12px", padding: "0px 10px" }}
                              />
                              <br />
                              <center>
                                <button
                                  onClick={() => {
                                    if (!drawingMode) {
                                      alert("Select mode first");
                                      return;
                                    }
                                    if (drawingMode === "line" && lines.length !== 1) {
                                      alert("Draw exactly 1 line");
                                      return;
                                    }
                                    if (drawingMode === "zone" && lines.length !== 2) {
                                      alert("Draw exactly 2 lines for zone");
                                      return;
                                    }
                                    if (!distance) {
                                      alert("Enter distance");
                                      return;
                                    }
                                    let newItem;
                                    if (drawingMode === "line") {
                                      newItem = createLinePayload(lines[0], Number(distance));
                                    }
                                    if (drawingMode === "zone") {
                                      newItem = createZonePayload(lines, Number(distance));
                                    }
                                    const finalPayload = {
                                      items: [...previousApiLinesData, newItem],
                                      default_distance_m: Number(distance),
                                    };
                                    console.log("payload====>", finalPayload);
                                    // fetch(activeCarDetails?.raw?.tunnel_info?.[0] + "/save-lines", {
                                    //   method: "POST",
                                    //   headers: { "Content-Type": "application/json" },
                                    //   body: JSON.stringify(finalPayload),
                                    // });
                                    // setShowDistanceInput(false);
                                    // setDistance("");
                                    // setLines([]);
                                    // setCurrentLine([]);
                                    // setDrawingMode(null);
                                    //getVideoLineDetails();
                                  }}
                                  className="mainButton"
                                  style={{ borderRadius: "10px", margin: "3px 0px 0px 1px" }}
                                >
                                  Submit
                                </button>
                              </center>
                            </div>
                          )}
                          {videoLoading[cameraKey] && (
                            <div className="loader-overlay"><div className="loader"></div></div>
                          )}
                          {videoErrors[cameraKey] && (
                            <div className="error-overlay">{videoErrors[cameraKey]}</div>
                          )}
                        </div>
                        {isHovered && videoSegments?.length >= 3 && (
                          <button
                            onClick={() => handlePinClick(index)}
                            style={{
                              zIndex: 1000, position: 'absolute', top: '50%', left: '50%',
                              borderRadius: '10px', padding: '5px 10px',
                              cursor: cameraOrder.length > 1 ? 'pointer' : 'not-allowed', color: 'red',
                            }}
                            disabled={cameraOrder.length <= 1}
                          >
                            <PushPinIcon style={{ color: 'white', fontSize: 24 }} />
                          </button>
                        )}
                        {displayIndex !== cameraOrder.length - 1 ? null : (
                          <div style={{ marginLeft: dynamicMarginLeft, display: 'flex', gap: '18px', zIndex: 999, padding: '3px 0px 0px 0px', borderRadius: '5px', marginTop: "0px" }}>
                            <div
                              style={{
                                position: "absolute",
                                top: "22px",
                                right: "15px",
                                zIndex: 999,
                                pointerEvents: "auto",
                                display: "flex",
                                alignItems: "center",
                                gap: "3px",
                                background: "rgba(0,0,0,0.5)",
                                padding: "6px 10px",
                                borderRadius: "20px",
                                backdropFilter: "blur(6px)",
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <SmartToyIcon
                                style={{
                                  color: "#fff",
                                  fontSize: "18px",
                                  pointerEvents: "none",
                                }}
                              />
                              <span
                                style={{
                                  color: "#fff",
                                  fontSize: "13px",
                                  pointerEvents: "none",
                                }}
                              >
                                AI Mode
                              </span>
                              <AISwitch
                                checked={aiMode}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  setAiMode(e.target.checked);
                                }}
                              />
                            </div>

                            {aiMode && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "60px",
                                  right: "10px",
                                  width: "200px",
                                  background: "rgba(0,0,0,0.7)",
                                  backdropFilter: "blur(12px)",
                                  borderRadius: "12px",
                                  padding: "5px",
                                  border: "1px solid rgba(255,255,255,0.1)",
                                  color: "#fff",
                                  zIndex: 1000,
                                  fontSize: "12px",
                                }}
                              >
                                <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
                                  AI Features
                                </div>

                                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                  {[
                                    { key: "ttc", label: "TTC/PET Line" },
                                    // { key: "trajectory", label: "Trajectory" },
                                    { key: "lineZone", label: "Line & Zone" },
                                  ].map((item) => (
                                    <label
                                      key={item.key}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "6px 10px",
                                        borderRadius: "8px",
                                        border: "1px solid rgba(255,255,255,0.15)",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span>{item.label}</span>

                                      <input
                                        type="checkbox"
                                        checked={features[item.key as FeatureKey]}
                                        onChange={() => toggleFeature(item.key as FeatureKey)}
                                      />
                                    </label>
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* Export button hidden. The dialog below is left in place so it
                                can be brought back by uncommenting this alone. */}
                            {/* <button style={{ color: "#333" }} onClick={() => setOpenExportModal(true)}>
                                <FileUploadIcon fontSize="small" titleAccess="Export data in excel" />
                                </button> */}

                            <Dialog
                              open={openExportModal}
                              onClose={() => !exportLoading && setOpenExportModal(false)}
                              maxWidth="xs"
                              fullWidth
                            >
                              <DialogTitle
                                style={{
                                  fontWeight: 600,
                                  fontSize: "18px",
                                }}
                              >
                                Select Export Type
                              </DialogTitle>

                              {exportLoading ? (
                                <div
                                  style={{
                                    padding: "40px 20px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <CircularProgress size={35} />

                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      color: "#666",
                                    }}
                                  >
                                    Exporting data...
                                  </p>
                                </div>
                              ) : (
                                <>
                                  <DialogContent>
                                    <RadioGroup
                                      value={selectedExportType}
                                      onChange={(e) => setSelectedExportType(e.target.value)}
                                    >
                                      <FormControlLabel
                                        value="AIData"
                                        control={<Radio />}
                                        label="AI Data"
                                      />

                                      <FormControlLabel
                                        value="TTCData"
                                        control={<Radio />}
                                        label="TTC Data"
                                      />

                                      <FormControlLabel
                                        value="PETData"
                                        control={<Radio />}
                                        label="PET Data"
                                      />
                                    </RadioGroup>
                                  </DialogContent>

                                  <DialogActions style={{ padding: "16px" }}>
                                    <Button
                                      onClick={() => setOpenExportModal(false)}
                                      variant="outlined"
                                      color="inherit"
                                    >
                                      Cancel
                                    </Button>

                                    <Button
                                      onClick={getExportDataInExcel}
                                      variant="contained"
                                      style={{
                                        background: "#ff7a00",
                                        color: "#fff",
                                      }}
                                    >
                                      Export
                                    </Button>
                                  </DialogActions>
                                </>
                              )}
                            </Dialog>

                            {/* <button style={{ color: "#333" }} onClick={() => setShowVideoChart(prev => !prev)}>
                              <AssessmentIcon titleAccess="Show Video Chart" />
                            </button> */}
                            <button onClick={fiveSecBack} style={{ background: 'none', border: 'none', color: '#000', cursor: 'pointer' }}>
                              <ClockFiveIcon title="Rewind 5 Seconds" />
                            </button>
                            <button onClick={() => setShowSpeedOptions(!showSpeedOptions)} style={{ background: 'none', border: 'none', color: '#000', cursor: 'pointer' }}>
                              <p style={{ margin: "0px", fontWeight: "bold", fontSize: "13px" }} title="Set Video Playback Speed">
                                {playbackRate}X
                              </p>
                            </button>
                            <button
                              onClick={togglePlayPause}
                              disabled={isJumping}
                              style={{ background: 'none', color: '#000', cursor: 'pointer', border: "2px solid #ff7a00", borderRadius: "50%", width: "27px", height: "26px" }}
                            >
                              {isPlaying
                                ? <PauseIcon style={{ fontSize: "25px", marginTop: "-6px" }} titleAccess="Pause Video" />
                                : <PlayArrowIcon style={{ fontSize: "25px", marginTop: "-6px" }} titleAccess="Play Video" />
                              }
                            </button>
                            <button onClick={fiveSecForward} style={{ background: 'none', border: 'none', color: '#000', cursor: 'pointer' }}>
                              <RefreshCircleIcon title="Forward 5 Seconds" />
                            </button>
                            {showSpeedOptions && (
                              <div style={{ position: 'absolute', bottom: '50px', left: '10px', background: 'rgba(0,0,0,0.7)', padding: '8px', borderRadius: '5px', display: 'flex', gap: '10px', zIndex: 1000 }}>
                                {videoPlaySec?.map(speed => (
                                  <button
                                    key={speed}
                                    onClick={() => { setPlaybackRate(speed); setShowSpeedOptions(false); }}
                                    style={{ background: playbackRate === speed ? 'white' : 'transparent', color: playbackRate === speed ? 'black' : 'white', border: 'none', borderRadius: '3px', padding: '5px 8px', cursor: 'pointer' }}
                                    title={`Set video playback speed to ${speed}x`}
                                  >
                                    {speed}x
                                  </button>
                                ))}
                              </div>
                            )}
                            <button style={{ color: "#333" }}>
                              <AccessTimeIcon onClick={() => setShowTimeOptions(!showTimeOptions)} titleAccess="Select Time Filters" />
                            </button>
                            {showTimeOptions && (
                              <div style={{ position: 'absolute', bottom: '50px', left: '10px', background: 'rgba(0,0,0,0.85)', padding: '10px', borderRadius: '8px', display: 'flex', flexDirection: 'column', gap: '6px', zIndex: 1000, minWidth: '140px' }}>
                                <p style={{ color: 'white', margin: '0 0 4px 0', fontSize: '11px', opacity: 0.6 }}>Select time filters</p>
                                {videoLastData.map(value => {
                                  const isSelected = activeTimeFilters.includes(value);
                                  return (
                                    <button
                                      key={value}
                                      onClick={() => setActiveTimeFilters(prev => isSelected ? prev.filter(f => f !== value) : [...prev, value])}
                                      style={{ background: isSelected ? '#ff7a00' : 'transparent', color: 'white', border: '1px solid', borderColor: isSelected ? '#ff7a00' : 'rgba(255,255,255,0.3)', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer', textAlign: 'left', fontSize: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                    >
                                      {value}
                                      {isSelected && <span>✓</span>}
                                    </button>
                                  );
                                })}
                                {activeTimeFilters.length > 0 && (
                                  <>
                                    <button onClick={() => { setActiveTimeFilters([]); setShowTimeOptions(false); }} style={{ marginTop: '4px', background: 'red', color: 'white', border: 'none', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer', fontSize: '12px' }}>
                                      Clear All
                                    </button>
                                    <button onClick={() => setActiveTimeFilters([])} style={{ background: 'none', border: '1px solid red', borderRadius: '4px', color: 'red', fontSize: '11px', fontWeight: 'bold', padding: '2px 6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '3px' }}>
                                      {activeTimeFilters.length === 1 ? activeTimeFilters[0] : `${activeTimeFilters.length} filters`} ✕
                                    </button>
                                  </>
                                )}
                              </div>
                            )}
                            <button
                              onClick={toggleFullscreen}
                              disabled={isJumping}
                              style={{ background: 'none', border: 'none', color: '#000', cursor: 'pointer', marginLeft: view === 'Map' ? '95%' : '55%' }}
                            >
                              <RatioIcon title="Toggle Fullscreen Video" />
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="no-video" style={{ textAlign: "center" }}>
                        {displayIndex === cameraOrder.length - 1 && !isSDCard && (
                          <div style={{ position: 'fixed', left: view === 'Map' ? '40%' : '47%', display: 'flex', gap: '18px', zIndex: 999, padding: '3px 0px 0px 0px', borderRadius: '5px', marginTop: "316px" }} />
                        )}
                        {isSDCard ? 'Video not available on server.' : 'No video available.'}
                      </div>
                    )}

                    {(segment !== undefined && !isSDCard) && (
                      <>
                        <div style={{ position: 'absolute', left: videoSegments?.length === 2 ? '4%' : '2%', top: '13%', transform: 'translate(-50%, -50%)', zIndex: 10, background: "rgba(0,0,0,0.5)", borderRadius: "10px", lineHeight: "32px" }}>
                          {/* <button>
                            <CropFreeIcon titleAccess="Click To Full Screen" onClick={() => toggleSingleVideoFullscreen(index)} style={{ color: 'red' }} />
                          </button> */}
                          {/* <br /> */}
                          <button>
                            <AutorenewIcon titleAccess="Click To Rotate Video" onClick={() => handleRotateVideo(cameraKey)} style={{ color: 'red' }} />
                          </button>
                          <br />
                          {!recordingState[cameraKey] && !recordedUrls[cameraKey] && (
                            <button onClick={() => startRecording(cameraKey)}>
                              <FiberManualRecordIcon style={{ color: 'red' }} titleAccess="Click To Start Recording" />
                            </button>
                          )}
                          {recordingState[cameraKey] && (
                            <button onClick={() => stopRecording(cameraKey)}>
                              <StopIcon titleAccess="Click To Stop Recording" />
                            </button>
                          )}
                          {recordedUrls[cameraKey] && (
                            <a href={recordedUrls[cameraKey]!} download={`recording-${cameraKey}.webm`}>
                              <button>
                                <CloudDownloadIcon titleAccess="Click To Download Recorded Video" style={{ color: "#fff" }} />
                              </button>
                            </a>
                          )}
                        </div>
                        {recordingState[cameraKey] && (
                          <div style={{ color: 'red', fontWeight: 'bold', zIndex: 999, position: "absolute", padding: "0px 20px" }}>
                            Recording: {formatTime(recordingTimes[cameraKey] || 0)}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
            </div>

            {showVideoChart && (
              <div style={{ position: 'absolute', bottom: '104px', left: "-21px", right: 2, zIndex: 9999, padding: '0 10px' }}>
                <VideoChart value={currentTime} segments={filteredVideoSegments} />
              </div>
            )}

            <div className="timeline-wrapper" style={{ marginTop: "15px" }}>
              <ProgressScale
                key={`${videoSegments}`}
                value={currentTime}
                segments={filteredVideoSegments}
                onChange={handleTimelineChange}
                bufferedUntil={bufferedUntil}
              />
            </div>
            <div className="stepper-wrapper">

            </div>
          </div>
        </Col>
      ) : (
        <Col>
          <div style={{ width: '100%', height: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'relative', overflow: 'visible', background: "#333" }}>
            <div>Playback video not found</div>
          </div>
          {/* No playable video from the board (e.g. it is offline), but the
              server still knows what was recorded and has the snapshots. */}
          <div className="timeline-wrapper" style={{ marginTop: "15px" }}>
            <ProgressScale value={0} segments={[]} onChange={() => { }} independentZoom />
          </div>
        </Col>
      )
      }
    </Row >
  );
};

export default React.memo(MultiVideoPlayerCctv);

// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import ReactPlayer from 'react-player';
// import { Col, Row } from "reactstrap";
// import PlayArrowIcon from '@mui/icons-material/Stop';
// import PauseIcon from '@mui/icons-material/Pause';
// import PushPinIcon from '@mui/icons-material/PushPin';
// import AutorenewIcon from '@mui/icons-material/Autorenew';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import StopIcon from '@mui/icons-material/StopCircle';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import { MultiVideoPlayerProps, VideoSegment } from '../../../utils/types';
// import ProgressScale from '../../video-player/progressScale';
// import { CircularProgress } from "@mui/material";
// import showToast from '../../../utils/toast';
// import { debounce } from 'lodash';
// import { colors } from '../../../constants/colors';
// import { ArrowBack } from '@mui/icons-material';
// import { useDispatch, useSelector } from 'react-redux';
// import { setActiveIndex } from '../../../redux/reducers/service-reducer';
// import { Stage, Layer, Rect, Line, Text, Circle, Group } from "react-konva";
// import Konva from "konva";
// import { ClockFiveIcon } from '../../../utils/ClockFiveIcon';
// import { RefreshCircleIcon } from '../../../utils/RefreshCircleIcon';
// import { RatioIcon } from '../../../utils/rationIcon';
// import dayjs from 'dayjs';
// import { useMediaQuery, useTheme } from '@mui/material';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import VideoChart from '../../video-player/videoChart';
// // import "./cctvViewPlayer.css";
// import { RootState } from '../../../redux/store';
// import { CLASS_COLORS } from '../../../utils/colors';
// import { Switch } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import SmartToyIcon from '@mui/icons-material/AutoAwesome';
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import { getDeviceTtcPetLine, getExportData, getExportDataTtcPet } from '../../../redux/actions/service-action';
// import { formatDateTimeRange } from '../../../utils/methods';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
// } from "@mui/material";

// const MultiVideoPlayerCctv: React.FC<MultiVideoPlayerProps> = ({
//   videoSegments,
//   timeFilterData,
//   playVideoTime,
//   onTimeChange = () => { },
//   isSDCard = true,
//   playingStatus,
//   lineData,
//   previousApiLinesData,
//   rawApiLines,
//   zoneData,
//   drawingMode,
//   setDrawingMode,
//   lines = [],
//   setLines = () => { },
//   ttcCountData,
//   petCountData
// }) => {
//   const [currentTime, setCurrentTime] = useState<number>(playVideoTime ?? 0);
//   useEffect(() => {
//     if (playVideoTime !== undefined && playVideoTime !== null) {
//       setCurrentTime(playVideoTime);
//       updateVideoSources(playVideoTime, true);
//     }
//   }, [playVideoTime]);
//   const [isPlaying, setIsPlaying] = useState<boolean>(false);
//   const [muted, setMuted] = useState<boolean>(true);
//   const [videoUrls, setVideoUrls] = useState<Record<string, string>>({});
//   const [lastProgrammaticUpdate, setLastProgrammaticUpdate] = useState<number>(0);
//   const [targetTime, setTargetTime] = useState<number | null>(null);
//   const [isJumping, setIsJumping] = useState<boolean>(false);
//   const [videoLoading, setVideoLoading] = useState<Record<string, boolean>>({});
//   const [videoErrors, setVideoErrors] = useState<Record<string, string | null>>({});
//   const [selectedCamera, setSelectedCamera] = useState<number | null>(null);
//   const containerRef = useRef<HTMLDivElement>(null);
//   const videoContainerRefs = useRef<Record<string, HTMLDivElement | null>>({});
//   const [isHovered, setIsHovered] = useState(false);
//   const [videoRotation, setVideoRotation] = useState<{ [key: string]: number }>({});
//   const [activeTimeFilters, setActiveTimeFilters] = useState<string[]>([]);
//   const [videoLoader, setVideoLoader] = useState<boolean>(false);
//   const videoLoaderTimeoutRef = useRef<NodeJS.Timeout | null>(null);
//   const currentSegmentRef = useRef<string>("");
//   const [exportLoading, setExportLoading] = useState(false);
//   const [displayScale, setDisplayScale] = useState<any>({
//     renderW: 0,
//     renderH: 0,
//     offsetX: 0,
//     offsetY: 0,
//     scaleX: 1,
//     scaleY: 1
//   });
//   const view = useSelector((state: any) => state.ui?.view || "Dashboard");
//   const [isSegmentSwitching, setIsSegmentSwitching] = useState(false);
//   const [cameraOrder, setCameraOrder] = useState<number[]>(
//     Array.isArray(videoSegments) ? videoSegments.map((_, index) => index) : []
//   );
//   const [playbackRate, setPlaybackRate] = useState(1);
//   const [showSpeedOptions, setShowSpeedOptions] = useState(false);
//   const [showTimeOptions, setShowTimeOptions] = useState(false);
//   const videoPlaySec = [0.5, 1, 1.5, 2, 3];
//   const videoLastData = ["Last 5 Min", "Last 15 Min", "Last 30 Min", "Last 1 Hour", "Last 3 Hours", "Last 6 Hours", "Last 12 Hours"];
//   const { activeCarDetails } = useSelector((state: RootState) => state.service);
//   const videoSectionRef = useRef(null);
//   const playerRefs = useRef<{ [key: string]: ReactPlayer | null }>({});
//   const [recordingState, setRecordingState] = useState<{ [key: string]: boolean }>({});
//   const [recordedUrls, setRecordedUrls] = useState<{ [key: string]: string | null }>({});
//   const recorderRefs = useRef<{ [key: string]: MediaRecorder | null }>({});
//   const chunksRefs = useRef<{ [key: string]: Blob[] }>({});
//   const [recordingTimes, setRecordingTimes] = useState<{ [key: string]: number }>({});
//   const intervalRefs = useRef<{ [key: string]: NodeJS.Timeout | null }>({});
//   const timeoutRef = useRef<NodeJS.Timeout | null>(null);
//   const bufferTimeouts = useRef<Record<string, NodeJS.Timeout | null>>({});
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });
//   const [openExportModal, setOpenExportModal] = useState(false);
//   const [selectedExportType, setSelectedExportType] = useState("AI Data");
//   const [ttcPetLineData, setTtcPetData] = useState<any>(null);
//   const isDrawingMode = drawingMode !== null;
//   const [isDrawing, setIsDrawing] = useState(false);
//   const [currentLine, setCurrentLine] = useState<number[]>([]);
//   const [distance, setDistance] = useState("");
//   const [lineName, setLineName] = useState("");
//   const [showDistanceInput, setShowDistanceInput] = useState(false);
//   const [showVideoChart, setShowVideoChart] = useState(false);
//   const FPS = 25;
//   const [objects, setObjects] = useState<any[]>([]);
//   const [tracks, setTracks] = useState<any[]>([]);
//   const stageRef = useRef<Konva.Stage | null>(null);
//   const jsonCache = useRef<any>({});
//   const currentJson = useRef<any>(null);
//   const lastSegment = useRef<number | null>(null);
//   const trackHistory = useRef<Record<string | number, number[]>>({});
//   const { selectedDate } = useSelector((state: any) => state.service);
//   const prefetchedSegments = useRef<Set<string>>(new Set());
//   const rafRef = useRef<number | null>(null);
//   const lastRenderedFrame = useRef<number>(-1);
//   const [trajectoryLines, setTrajectoryLines] = useState<any[]>([]);
//   const [bufferedUntil, setBufferedUntil] = useState<number>(0);
//   type FeatureKey = "ttc" | "pet" | "videoAnalytics" | "trajectory" | "lineZone";
//   const [aiMode, setAiMode] = useState(false);

//   const [features, setFeatures] = useState<Record<FeatureKey, boolean>>({
//     ttc: false,
//     pet: false,
//     videoAnalytics: false,
//     trajectory: false,
//     lineZone: false,
//   });

//   const featuresRef = useRef(features);
//   useEffect(() => { featuresRef.current = features; }, [features]);

//   const canvasSizeRef = useRef(canvasSize);
//   useEffect(() => { canvasSizeRef.current = canvasSize; }, [canvasSize]);

//   const getTtcData = async () => {
//     const tunnelUrl = activeCarDetails?.raw?.tunnel_info?.[0];
//     try {
//       const res: any = await getDeviceTtcPetLine(tunnelUrl);
//       if (res) {
//         setTtcPetData(res);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const toggleFeature = async (key: FeatureKey) => {
//     const enable = !features[key];
//     const resetFeatures = {
//       ttc: false,
//       pet: false,
//       videoAnalytics: false,
//       trajectory: false,
//       lineZone: false,
//     };
//     setFeatures({
//       ...resetFeatures,
//       [key]: enable,
//     });
//     if (key === "ttc" && enable) {
//       await getTtcData();
//     }
//   };

//   const getSloatFromSeconds = useCallback((seconds: number): string => {
//     const hh = String(Math.floor(seconds / 3600)).padStart(2, "0");
//     const mm = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
//     return `${hh}${mm}00`;
//   }, []);

//   const sloatTime = useMemo(() => getSloatFromSeconds(currentTime), [currentTime, getSloatFromSeconds]);

//   useEffect(() => {
//     playingStatus(isPlaying);
//   }, [isPlaying]);

//   useEffect(() => {
//     jsonCache.current = {};
//     currentJson.current = null;
//     lastSegment.current = null;
//     trackHistory.current = {};
//     lastRenderedFrame.current = -1;
//   }, [sloatTime]);

//   // ==================== INITIAL VIDEO STATES ====================
//   const initializeVideoStates = useMemo(() => {
//     const initialUrls: Record<string, string> = {};
//     const initialLoading: Record<string, boolean> = {};
//     const initialErrors: Record<string, string | null> = {};
//     videoSegments.forEach((_, index) => {
//       const cameraKey = `video-${index}`;
//       initialUrls[cameraKey] = '';
//       initialLoading[cameraKey] = false;
//       initialErrors[cameraKey] = null;
//     });
//     return { initialUrls, initialLoading, initialErrors };
//   }, [videoSegments]);

//   useEffect(() => {
//     setVideoUrls(initializeVideoStates.initialUrls);
//     setVideoLoading(initializeVideoStates.initialLoading);
//     setVideoErrors(initializeVideoStates.initialErrors);
//   }, [initializeVideoStates]);

//   // ==================== TIME HELPERS ====================
//   const timeToSeconds = useCallback((timeStr: string): number => {
//     if (!timeStr) return 0;
//     const parts = timeStr.split(":").map(Number);
//     if (parts.length !== 3) return 0;
//     const [hours, minutes, seconds] = parts;
//     return hours * 3600 + minutes * 60 + seconds;
//   }, []);

//   const findVideoSegment = useCallback(
//     (time: number, cameraIndex: number) => {
//       const segments = videoSegments?.[cameraIndex] || [];
//       for (const segment of segments) {
//         const start = segment.start;
//         const end = segment.end;
//         if (time >= start && time < end) {
//           return segment;
//         }
//       }
//       return undefined;
//     },
//     [videoSegments]
//   );

//   const hasSegmentAtTime = useCallback((time: number) => {
//     return videoSegments.some((_, index) => findVideoSegment(time, index));
//   }, [videoSegments, findVideoSegment]);

//   const findNearestValidTime = useCallback((time: number, direction: 'forward' | 'backward' = 'forward') => {
//     let nearest = time;
//     const step = direction === 'forward' ? 1 : -1;
//     while (!hasSegmentAtTime(nearest) && nearest >= 0 && nearest < 86400) {
//       nearest += step;
//     }
//     return nearest;
//   }, [hasSegmentAtTime]);

//   const prefetchSegment = useCallback((url: string) => {
//     if (!url) return;
//     if (prefetchedSegments.current.has(url)) {
//       return;
//     }
//     prefetchedSegments.current.add(url);
//     fetch(url, {
//       method: "GET",
//       cache: "force-cache",
//     }).catch(() => { });
//   }, []);

//   const handleVideoLoader = useCallback(() => {
//     const now = Date.now();
//     if (now - lastProgrammaticUpdate < 500) return;
//     setVideoLoader(true);
//     if (videoLoaderTimeoutRef.current) {
//       clearTimeout(videoLoaderTimeoutRef.current);
//     }
//     videoLoaderTimeoutRef.current = setTimeout(() => {
//       setVideoLoader(false);
//       videoLoaderTimeoutRef.current = null;
//     }, 900);
//   }, [lastProgrammaticUpdate]);

//   // ==================== VIDEO SOURCES ====================
//   const updateVideoSources = useCallback(
//     (time: number, isProgrammatic = false) => {
//       const formattedDate = dayjs(selectedDate).format("YYYYMMDD");
//       const cleanTime = Math.floor(time);
//       const formattedTime = [
//         Math.floor(cleanTime / 3600),
//         Math.floor((cleanTime % 3600) / 60),
//         cleanTime % 60,
//       ]
//         .map((v) => String(v).padStart(2, "0"))
//         .join("");
//       const clickedDateTime = `${formattedDate}T${formattedTime}`;
//       const newUrls: Record<string, string> = {};
//       videoSegments.forEach((_, index) => {
//         const cameraKey = `video-${index}`;
//         const segment = findVideoSegment(time, index);
//         if (!segment) {
//           newUrls[cameraKey] = "";
//           return;
//         }
//         const segmentKey = segment.specific_file_url;
//         // User clicked timeline
//         if (isProgrammatic) {
//           currentSegmentRef.current = segmentKey;
//           newUrls[cameraKey] =
//             `${segment.specific_file_url}?start=${clickedDateTime}`;
//           return;
//         }
//         // Auto playback
//         if (currentSegmentRef.current !== segmentKey) {
//           setVideoLoading(prev => ({
//             ...prev,
//             [cameraKey]: true,
//           }));
//           currentSegmentRef.current = segmentKey;
//           const segmentStartSeconds = segment.start;
//           const segmentTime = [
//             Math.floor(segmentStartSeconds / 3600),
//             Math.floor((segmentStartSeconds % 3600) / 60),
//             segmentStartSeconds % 60,
//           ]
//             .map((v) => String(v).padStart(2, "0"))
//             .join("");
//           const segmentStartDateTime =
//             `${formattedDate}T${segmentTime}`;
//           newUrls[cameraKey] =
//             `${segment.specific_file_url}?start=${segmentStartDateTime}`;
//           // console.log(
//           //   "AUTO SEGMENT LOAD",
//           //   segmentStartDateTime
//           // );
//         } else {
//           // Same segment -> keep old URL
//           newUrls[cameraKey] = videoUrls[cameraKey];
//         }
//       });
//       setVideoUrls((prev) => {
//         const changed =
//           JSON.stringify(prev) !== JSON.stringify(newUrls);
//         return changed ? newUrls : prev;
//       });
//       if (isProgrammatic) {
//         setLastProgrammaticUpdate(Date.now());
//       }
//     },
//     [
//       selectedDate,
//       videoSegments,
//       findVideoSegment,
//       videoUrls,
//     ]
//   );

//   const debouncedHandleTimelineChange = useMemo(() =>
//     debounce(() => {
//       setIsScrolled(true);
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//       timeoutRef.current = setTimeout(() => {
//         setIsScrolled(false);
//       }, 5000);
//     }, 500),
//     []
//   );

//   const handleTimelineChange = useCallback(
//     (seconds: number) => {
//       debouncedHandleTimelineChange()
//       handleVideoLoader();
//       const now = Date.now();
//       if (now - lastProgrammaticUpdate < 500 || (targetTime !== null && Math.abs(seconds - targetTime) > 1)) {
//         return;
//       }
//       setCurrentTime(seconds);
//       setTargetTime(null);
//       updateVideoSources(seconds, true);
//       onTimeChange(seconds);

//     },
//     [lastProgrammaticUpdate, targetTime, updateVideoSources, onTimeChange, handleVideoLoader]
//   );

//   const jumpToTime = useCallback(
//     (startTime: string) => {
//       if (isJumping) return;
//       setIsJumping(true);
//       const seconds = timeToSeconds(startTime);
//       setTargetTime(seconds);
//       setCurrentTime(seconds);
//       updateVideoSources(seconds, true);
//       setIsPlaying(false);
//       onTimeChange(seconds);
//       setTimeout(() => setIsJumping(false), 100);
//     },
//     [isJumping, timeToSeconds, updateVideoSources, onTimeChange]
//   );

//   useEffect(() => {
//     return () => {
//       if (rafRef.current) cancelAnimationFrame(rafRef.current);
//     };
//   }, []);

//   const togglePlayPause = useCallback(() => {
//     setIsPlaying(prev => !prev);
//   }, []);

//   const toggleFullscreen = useCallback(async () => {
//     if (!containerRef.current) return;
//     if (!document.fullscreenElement) {
//       try { await containerRef.current.requestFullscreen(); } catch (err) { console.error(err); }
//     } else {
//       try { await document.exitFullscreen(); } catch (err) { console.error(err); }
//     }
//   }, []);

//   useEffect(() => {
//     const handleFullscreenChange = () => {
//       if (!document.fullscreenElement) setSelectedCamera(null);
//     };
//     document.addEventListener('fullscreenchange', handleFullscreenChange);
//     return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
//   }, []);

//   const handlePinClick = (index: number) => {
//     const newCameraOrder = [...cameraOrder];
//     const currentIndex = newCameraOrder.indexOf(index);
//     if (currentIndex === -1 || cameraOrder.length <= 1) return;
//     newCameraOrder.splice(currentIndex, 1);
//     newCameraOrder.push(index);
//     setCameraOrder(newCameraOrder);
//   };

//   const videoCount = useMemo(() => videoSegments?.length || 1, [videoSegments]);
//   const isOdd = useMemo(() => videoCount % 2 !== 0, [videoCount]);
//   const isSingle = useMemo(() => videoCount === 1, [videoCount]);

//   const handleRotateVideo = (cameraKey: string) => {
//     setVideoRotation(prev => ({ ...prev, [cameraKey]: (prev[cameraKey] || 0) + 90 }));
//   };

//   const startRecording = (cameraKey: string) => {
//     const videoElement: any = playerRefs.current[cameraKey]?.getInternalPlayer() as HTMLVideoElement;
//     const rotation = videoRotation[cameraKey] || 0;
//     if (!videoElement) { showToast("Could not access the internal video element.", "e"); return; }
//     if (videoElement.readyState < 3) { showToast("Please start playing the video first before recording.", "e"); return; }
//     if (typeof videoElement.captureStream !== "function") { showToast("Video recording is not supported by your browser.", "e"); return; }
//     const canvas = document.createElement('canvas');
//     const ctx = canvas.getContext('2d')!;
//     const width = videoElement.videoWidth;
//     const height = videoElement.videoHeight;
//     if (rotation === 90 || rotation === 270) { canvas.width = height; canvas.height = width; }
//     else { canvas.width = width; canvas.height = height; }
//     const watermark = new Image();
//     watermark.src = "/watermark.png";
//     // const drawFrame = () => {
//     //   ctx.save();
//     //   ctx.clearRect(0, 0, canvas.width, canvas.height);
//     //   switch (rotation) {
//     //     case 90: ctx.translate(canvas.width, 0); ctx.rotate(Math.PI / 2); break;
//     //     case 180: ctx.translate(canvas.width, canvas.height); ctx.rotate(Math.PI); break;
//     //     case 270: ctx.translate(0, canvas.height); ctx.rotate((3 * Math.PI) / 2); break;
//     //   }
//     //   ctx.drawImage(videoElement, 0, 0, width, height);
//     //   if (watermark.complete) {
//     //     const aspectRatio = watermark.width / watermark.height;
//     //     const maxLogoWidth = Math.min(300, canvas.width * 0.18);
//     //     const logoWidth = Math.max(80, maxLogoWidth);
//     //     const logoHeight = logoWidth / aspectRatio;
//     //     ctx.globalAlpha = 0.7;
//     //     ctx.drawImage(watermark, canvas.width - logoWidth - 10, canvas.height - logoHeight - 10, logoWidth, logoHeight);
//     //     ctx.globalAlpha = 1;
//     //   }
//     //   ctx.restore();
//     //   requestAnimationFrame(drawFrame);
//     // };

//     const drawFrame = () => {
//       ctx.save();
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       switch (rotation) {
//         case 90: ctx.translate(canvas.width, 0); ctx.rotate(Math.PI / 2); break;
//         case 180: ctx.translate(canvas.width, canvas.height); ctx.rotate(Math.PI); break;
//         case 270: ctx.translate(0, canvas.height); ctx.rotate((3 * Math.PI) / 2); break;
//       }
//       ctx.drawImage(videoElement, 0, 0, width, height);

//       // NEW: draw TTC/PET Line & Line/Zone overlays into the recording if enabled
//       const liveFeatures = featuresRef.current;
//       const liveCanvasSize = canvasSizeRef.current;
//       if (
//         (liveFeatures.ttc || liveFeatures.lineZone) &&
//         stageRef.current &&
//         liveCanvasSize.width &&
//         liveCanvasSize.height
//       ) {
//         try {
//           const overlayCanvas = stageRef.current.toCanvas({ pixelRatio: 1 });
//           ctx.drawImage(
//             overlayCanvas,
//             0, 0, liveCanvasSize.width, liveCanvasSize.height,
//             0, 0, width, height
//           );
//         } catch (err) {
//           console.error("Overlay capture error", err);
//         }
//       }

//       ctx.restore();
//       if (watermark.complete) {
//         const aspectRatio = watermark.width / watermark.height;
//         const maxLogoWidth = Math.min(300, canvas.width * 0.18);
//         const logoWidth = Math.max(80, maxLogoWidth);
//         const logoHeight = logoWidth / aspectRatio;
//         ctx.globalAlpha = 0.7;
//         ctx.drawImage(watermark, canvas.width - logoWidth - 10, canvas.height - logoHeight - 10, logoWidth, logoHeight);
//         ctx.globalAlpha = 1;
//       }
//       requestAnimationFrame(drawFrame);
//     };
//     drawFrame();
//     const stream = canvas.captureStream(30);
//     // const recorder = new MediaRecorder(stream);
//     const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp9')
//       ? 'video/webm;codecs=vp9'
//       : 'video/webm;codecs=vp8';

//     const recorder = new MediaRecorder(stream, {
//       mimeType,
//       videoBitsPerSecond: 8_000_000,
//     });

//     recorderRefs.current[cameraKey] = recorder;
//     chunksRefs.current[cameraKey] = [];
//     recorder.ondataavailable = (e) => { if (e.data.size > 0) chunksRefs.current[cameraKey].push(e.data); };
//     recorder.onstop = () => {
//       const blob = new Blob(chunksRefs.current[cameraKey], { type: 'video/webm' });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.style.display = 'none'; a.href = url; a.download = `recording-${cameraKey}.webm`;
//       document.body.appendChild(a); a.click(); document.body.removeChild(a);
//       if (intervalRefs.current[cameraKey]) { clearInterval(intervalRefs.current[cameraKey]!); intervalRefs.current[cameraKey] = null; }
//       setRecordingTimes((prev) => ({ ...prev, [cameraKey]: 0 }));
//       setRecordedUrls((prev) => { const updated = { ...prev }; delete updated[cameraKey]; return updated; });
//     };
//     recorder.start();
//     setRecordingState((prev) => ({ ...prev, [cameraKey]: true }));
//     setRecordingTimes((prev) => ({ ...prev, [cameraKey]: 0 }));
//     intervalRefs.current[cameraKey] = setInterval(() => {
//       setRecordingTimes((prev) => ({ ...prev, [cameraKey]: (prev[cameraKey] || 0) + 1 }));
//     }, 1000);
//   };

//   const stopRecording = (cameraKey: string) => {
//     const recorder = recorderRefs.current[cameraKey];
//     if (recorder) {
//       recorder.stop();
//       setRecordingState((prev) => ({ ...prev, [cameraKey]: false }));
//       if (intervalRefs.current[cameraKey]) { clearInterval(intervalRefs.current[cameraKey]!); intervalRefs.current[cameraKey] = null; }
//     }
//   };

//   const formatTime = (seconds: number) => {
//     const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
//     const secs = (seconds % 60).toString().padStart(2, '0');
//     return `${mins}:${secs}`;
//   };

//   const dispatch = useDispatch();
//   const { activeIndex } = useSelector((state: any) => state.service);
//   const onClickPlayBack = () => { dispatch(setActiveIndex(0)); };

//   // const updateScale = useCallback((container: HTMLDivElement, video: HTMLVideoElement) => {
//   //   if (!container || !video || !video.videoWidth || !video.videoHeight) return;
//   //   const containerW = container.clientWidth;
//   //   const containerH = container.clientHeight;
//   //   const videoW = video.videoWidth;
//   //   const videoH = video.videoHeight;
//   //   const videoAspect = videoW / videoH;
//   //   const containerAspect = containerW / containerH;
//   //   let renderW = containerW, renderH = containerH, offsetX = 0, offsetY = 0;
//   //   if (containerAspect > videoAspect) {
//   //     renderH = containerH; renderW = renderH * videoAspect; offsetX = (containerW - renderW) / 2;
//   //   } else {
//   //     renderW = containerW; renderH = renderW / videoAspect; offsetY = (containerH - renderH) / 2;
//   //   }
//   //   setDisplayScale({
//   //     renderW,
//   //     renderH,
//   //     offsetX,
//   //     offsetY,
//   //     scaleX: renderW / videoW,
//   //     scaleY: renderH / videoH,
//   //   });
//   //   setCanvasSize({ width: containerW, height: containerH });
//   // }, []);

//   const updateScale = useCallback((container: HTMLDivElement, video: HTMLVideoElement) => {
//     if (!container || !video || !video.videoWidth || !video.videoHeight) return;
//     const containerW = container.clientWidth;
//     const containerH = container.clientHeight;
//     const videoW = video.videoWidth;
//     const videoH = video.videoHeight;
//     const videoAspect = videoW / videoH;
//     const containerAspect = containerW / containerH;
//     let renderW, renderH;
//     if (containerAspect > videoAspect) {
//       renderW = containerW;
//       renderH = renderW / videoAspect;
//     } else {
//       renderH = containerH;
//       renderW = renderH * videoAspect;
//     }
//     const offsetX = (containerW - renderW) / 2;
//     const offsetY = (containerH - renderH) / 2;
//     setDisplayScale({
//       renderW,
//       renderH,
//       offsetX,
//       offsetY,
//       scaleX: renderW / videoW,
//       scaleY: renderH / videoH,
//     });
//     setCanvasSize({ width: containerW, height: containerH });
//   }, []);

//   const loadSegmentJson = useCallback(async (_segmentIndex: number) => {
//     const tunnelUrl = activeCarDetails?.raw?.tunnel_info?.[0];
//     if (!features?.videoAnalytics) return;
//     if (!tunnelUrl) return;
//     if (!isPlaying) return;
//     setObjects([]);
//     setTracks([]);
//     const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
//     if (jsonCache.current[sloatTime]) {
//       currentJson.current = jsonCache.current[sloatTime];
//       return;
//     }
//     try {
//       const url = `https://papli-desktop-3.taildfe778.ts.net/recordings_json/${formattedDate}/${sloatTime}/ai_results.json`;
//       const res = await fetch(url);
//       if (!res.ok) {
//         console.warn(`Failed to load JSON: ${res.status}`);
//         return;
//       }
//       const data = await res.json();
//       const frameMap: any = {};
//       (data.per_second || []).forEach((item: any) => {
//         frameMap[item.frame] = item;
//       });
//       jsonCache.current[sloatTime] = {
//         ...data,
//         frameMap
//       };
//       currentJson.current = jsonCache.current[sloatTime];
//     } catch (err) {
//       console.error("JSON LOAD ERROR", err);
//     }
//   }, [sloatTime, selectedDate]);

//   // ==================== STEP 2: renderDetections (FIXED) ====================
//   const renderDetections = useCallback((seconds: number) => {
//     if (!currentJson.current) {
//       setObjects([]);
//       setTracks([]);
//       return;
//     }
//     const fps = currentJson.current.fps || 25;
//     const OFFSET = 1;
//     const currentFrame = Math.round(seconds * fps) + OFFSET;
//     const frameData = currentJson.current.frameMap?.[currentFrame];
//     if (!frameData) {
//       return;
//     }
//     const detections = [
//       ...(frameData.people || []),
//       ...(frameData.vehicles || [])
//     ];
//     const DETECTION_WIDTH = 1280;
//     const DETECTION_HEIGHT = 720;
//     const scaleX = canvasSize.width / DETECTION_WIDTH;
//     const scaleY = canvasSize.height / DETECTION_HEIGHT;
//     const formatted: any[] = [];
//     const newTracks: any[] = [];
//     detections.forEach((obj: any) => {
//       const [x1, y1, x2, y2] = obj.bbox;
//       const scaledX1 = x1 * scaleX;
//       const scaledY1 = y1 * scaleY;
//       const scaledX2 = x2 * scaleX;
//       const scaledY2 = y2 * scaleY;
//       const centerX = (scaledX1 + scaledX2) / 2;
//       const centerY = (scaledY1 + scaledY2) / 2;
//       formatted.push({
//         id: obj.id,
//         label: obj.class,
//         x: scaledX1,
//         y: scaledY1,
//         width: scaledX2 - scaledX1,
//         height: scaledY2 - scaledY1,
//         centerX,
//         centerY,
//       });
//       if (!trackHistory.current[obj.id]) {
//         trackHistory.current[obj.id] = [];
//       }
//       const history = trackHistory.current[obj.id];
//       if (history.length >= 2) {
//         const lastX = history[history.length - 2];
//         const lastY = history[history.length - 1];
//         const dist = Math.hypot(centerX - lastX, centerY - lastY);
//         if (dist > 100) {
//           trackHistory.current[obj.id] = [];
//         }
//       }
//       trackHistory.current[obj.id].push(centerX, centerY);
//       if (trackHistory.current[obj.id].length > 100) {
//         trackHistory.current[obj.id].splice(0, 2);
//       }
//       newTracks.push({
//         id: obj.id,
//         points: trackHistory.current[obj.id],
//       });
//     });
//     setObjects(formatted);
//     setTracks(newTracks);
//   }, [canvasSize]);

//   // ==================== STEP 3: startDetectionLoop ====================

//   const isAnyVideoLoading = Object.values(videoLoading).some(Boolean);

//   // useEffect(() => {
//   //   if (!isPlaying || isAnyVideoLoading) return;
//   //   const interval = setInterval(() => {
//   //     setCurrentTime((prev) => {
//   //       const next = prev + 1;
//   //       onTimeChange(next);
//   //       return next;
//   //     });
//   //   }, 1000 / playbackRate);
//   //   return () => clearInterval(interval);
//   // }, [isPlaying, playbackRate, isAnyVideoLoading]);

//   // useEffect(() => {
//   //   if (!isPlaying || isAnyVideoLoading || isSegmentSwitching) return;
//   //   const interval = setInterval(() => {
//   //     setCurrentTime((prev) => {
//   //       const next = prev + 1;
//   //       return next;
//   //     });
//   //   }, 1000);
//   //   return () => clearInterval(interval);
//   // }, [
//   //   isPlaying,
//   //   isAnyVideoLoading,
//   //   isSegmentSwitching,
//   // ]);

//   // useEffect(() => {
//   //   if (!isPlaying || isAnyVideoLoading || isSegmentSwitching) return;
//   //   const interval = setInterval(() => {
//   //     setCurrentTime((prev) => {
//   //       const next = prev + 1;
//   //       return next;
//   //     });
//   //   }, 1000);
//   //   return () => clearInterval(interval);
//   // }, [
//   //   isPlaying,
//   //   isAnyVideoLoading,
//   //   isSegmentSwitching,
//   // ]);

//   useEffect(() => {
//     if (!isPlaying || isAnyVideoLoading || isSegmentSwitching) return;
//     const interval = setInterval(() => {
//       setCurrentTime((prev) => {
//         return prev + playbackRate;
//       });
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [
//     isPlaying,
//     playbackRate,
//     isAnyVideoLoading,
//     isSegmentSwitching,
//   ]);

//   useEffect(() => {
//     const segment = findVideoSegment(currentTime, 0);
//     if (!segment) return;
//     const segmentKey = segment.specific_file_url;
//     if (
//       currentSegmentRef.current &&
//       currentSegmentRef.current !== segmentKey
//     ) {
//       // console.log(
//       //   "SEGMENT CHANGED",
//       //   currentSegmentRef.current,
//       //   "=>",
//       //   segmentKey
//       // );
//       updateVideoSources(currentTime, false);
//     }
//   }, [
//     currentTime,
//     findVideoSegment,
//     updateVideoSources,
//   ]);

//   useEffect(() => {
//     const run = async () => {
//       if (isPlaying) return;
//       await loadSegmentJson(0);
//       const player = playerRefs.current['video-0'];
//       const video: any = player?.getInternalPlayer();
//       renderDetections(video?.currentTime ?? currentTime);
//     };
//     run();
//   }, [currentTime, isPlaying]);

//   useEffect(() => {
//     const cameraKey = "video-0";
//     const container = videoContainerRefs.current[cameraKey];
//     if (!container) return;
//     const tryUpdateScale = () => {
//       const player = playerRefs.current[cameraKey];
//       const video: any = player?.getInternalPlayer();
//       if (video && video.videoWidth && video.videoHeight) {
//         setTimeout(() => updateScale(container, video), 10);
//       } else {
//         setCanvasSize({ width: container.clientWidth, height: container.clientHeight });
//       }
//     };
//     const resizeObserver = new ResizeObserver(() => tryUpdateScale());
//     resizeObserver.observe(container);
//     setTimeout(tryUpdateScale, 100);
//     return () => resizeObserver.disconnect();
//   }, [updateScale]);

//   useEffect(() => {
//     const handleResizeOrChange = () => {
//       const cameraKey = "video-0";
//       const container = videoContainerRefs.current[cameraKey];
//       const player = playerRefs.current[cameraKey];
//       const video: any = player?.getInternalPlayer();
//       if (container && video && video.videoWidth) {
//         setTimeout(() => updateScale(container, video), 50);
//       }
//     };
//     window.addEventListener('resize', handleResizeOrChange);
//     document.addEventListener('fullscreenchange', handleResizeOrChange);
//     return () => {
//       window.removeEventListener('resize', handleResizeOrChange);
//       document.removeEventListener('fullscreenchange', handleResizeOrChange);
//     };
//   }, [updateScale]);

//   useEffect(() => {
//     const cameraKey = "video-0";
//     const container = videoContainerRefs.current[cameraKey];
//     if (!container) return;
//     const observer = new ResizeObserver(() => {
//       const player = playerRefs.current[cameraKey];
//       const video = player?.getInternalPlayer() as HTMLVideoElement;
//       if (video) setTimeout(() => updateScale(container, video), 50);
//     });
//     observer.observe(container);
//     const handleFullscreenOrRotate = () => {
//       const player = playerRefs.current[cameraKey];
//       const video = player?.getInternalPlayer() as HTMLVideoElement;
//       if (video) setTimeout(() => updateScale(container, video), 80);
//     };
//     window.addEventListener('resize', handleFullscreenOrRotate);
//     document.addEventListener('fullscreenchange', handleFullscreenOrRotate);
//     return () => {
//       observer.disconnect();
//       window.removeEventListener('resize', handleFullscreenOrRotate);
//       document.removeEventListener('fullscreenchange', handleFullscreenOrRotate);
//     };
//   }, [updateScale]);

//   const getLabelWidth = (label: string) => {
//     switch (label) {
//       case "person": return 50;
//       case "car": return 32;
//       case "truck": return 42;
//       case "bus": return 32;
//       case "motorcycle": return 80;
//       default: return 50;
//     }
//   };

//   const getNextName = (items: any[] = [], type: "line" | "region") => {
//     const prefix = type === "line" ? "line" : "zone";
//     const safeItems = Array.isArray(items) ? items : [];
//     const numbers = safeItems
//       .filter(item => item?.type === type)
//       .map(item => {
//         const name = type === "line" ? item?.line_name : item?.region_name;
//         const match = name?.match(/\d+/);
//         return match ? parseInt(match[0]) : 0;
//       });
//     const max = numbers.length > 0 ? Math.max(...numbers) : 0;
//     return `${prefix}${max + 1}`;
//   };

//   const createLinePayload = (line: number[], distance: number) => {
//     const { renderW, renderH, offsetX, offsetY } = displayScale;
//     const sourceWidth = 1920;
//     const sourceHeight = 1080;
//     return {
//       type: "line",
//       line_name: lineName || getNextName(rawApiLines?.items, "line"),
//       lx1: Number(
//         (((line[0] - offsetX) / renderW) * sourceWidth).toFixed(2)
//       ),
//       ly1: Number(
//         (((line[1] - offsetY) / renderH) * sourceHeight).toFixed(2)
//       ),
//       lx2: Number(
//         (((line[2] - offsetX) / renderW) * sourceWidth).toFixed(2)
//       ),
//       ly2: Number(
//         (((line[3] - offsetY) / renderH) * sourceHeight).toFixed(2)
//       ),
//       dist_m: distance,
//       sourceWidth,
//       sourceHeight,
//     };
//   };

//   const createZonePayload = (lines: number[][], distance: number) => {
//     const { renderW, renderH, offsetX, offsetY } = displayScale;
//     const sourceWidth = 1920;
//     const sourceHeight = 1080;
//     const convertX = (x: number) =>
//       Number((((x - offsetX) / renderW) * sourceWidth).toFixed(2));
//     const convertY = (y: number) =>
//       Number((((y - offsetY) / renderH) * sourceHeight).toFixed(2));
//     return {
//       type: "zone_occupancy",
//       region_name: lineName || getNextName(rawApiLines?.items, "region"),
//       dist_m: distance,
//       l1x1: convertX(lines[0][0]),
//       l1y1: convertY(lines[0][1]),
//       l1x2: convertX(lines[0][2]),
//       l1y2: convertY(lines[0][3]),
//       l2x1: convertX(lines[1][0]),
//       l2y1: convertY(lines[1][1]),
//       l2x2: convertX(lines[1][2]),
//       l2y2: convertY(lines[1][3]),
//       sourceWidth,
//       sourceHeight,
//     };
//   };
//   useEffect(() => {
//     if (drawingMode === "line" && lines.length === 1) {
//       setShowDistanceInput(true);
//     } else if (drawingMode === "zone" && lines.length === 2) {
//       setShowDistanceInput(true);
//     } else {
//       setShowDistanceInput(false);
//     }
//   }, [lines, drawingMode]);

//   const seekBySeconds = useCallback((seconds: number) => {
//     let newTime = currentTime + seconds;
//     newTime = Math.max(0, Math.min(86400, newTime));
//     if (!hasSegmentAtTime(newTime)) {
//       newTime = findNearestValidTime(
//         newTime,
//         seconds > 0 ? "forward" : "backward"
//       );
//     }
//     setCurrentTime(newTime);
//     onTimeChange(newTime);
//     updateVideoSources(newTime, true);
//   }, [
//     currentTime,
//     hasSegmentAtTime,
//     findNearestValidTime,
//     updateVideoSources,
//     onTimeChange,
//   ]);
//   const fiveSecBack = useCallback(() => seekBySeconds(-5), [seekBySeconds]);
//   const fiveSecForward = useCallback(() => seekBySeconds(5), [seekBySeconds]);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const dynamicMarginLeft = isMobile ? '23%' : (view === 'Map' ? '40%' : '40%');
//   const getFilterSeconds = (label: string): number => {
//     const map: Record<string, number> = {
//       "Last 5 Min": 5 * 60, "Last 15 Min": 15 * 60, "Last 30 Min": 30 * 60,
//       "Last 1 Hour": 60 * 60, "Last 3 Hours": 3 * 60 * 60,
//       "Last 6 Hours": 6 * 60 * 60, "Last 12 Hours": 12 * 60 * 60,
//     };
//     return map[label] ?? 0;
//   };
//   const filteredVideoSegments = useMemo(() => {
//     if (activeTimeFilters.length === 0) return videoSegments;
//     const maxDuration = Math.max(...activeTimeFilters.map(getFilterSeconds));
//     const windowStart = Math.max(0, currentTime - maxDuration);
//     const windowEnd = currentTime;
//     return videoSegments?.map(cameraSegments =>
//       cameraSegments
//         .filter((seg: VideoSegment) => seg.end > windowStart && seg.start < windowEnd)
//         .map((seg: VideoSegment) => ({
//           ...seg,
//           start: Math.max(seg.start, windowStart),
//           end: Math.min(seg.end, windowEnd),
//         }))
//     );
//   }, [activeTimeFilters, currentTime, videoSegments]);

//   // ==================== PROCESS TRAJECTORIES ====================
//   const processedTrajectories = useMemo(() => {
//     if (!lineData?.length || canvasSize.width === 0) return [];
//     const tracks = new Map<number, { points: number[], class: string, id: number }>();
//     lineData?.forEach((frame: any) => {
//       const people = frame.people || [];
//       people.forEach((person: any) => {
//         const id = person.id;
//         const cls = person.class || 'person';
//         const [x, y] = person.center || [0, 0];
//         if (!tracks.has(id)) {
//           tracks.set(id, { points: [], class: cls, id });
//         }
//         const track = tracks.get(id)!;
//         const scaledX = (x / 1280) * canvasSize.width;
//         const scaledY = (y / 720) * canvasSize.height;
//         track.points.push(scaledX, scaledY);
//       });
//     });
//     return Array.from(tracks.values());
//   }, [lineData, canvasSize]);

//   useEffect(() => {
//     setTrajectoryLines(processedTrajectories);
//   }, [processedTrajectories]);

//   const optimizeTrajectoryPoints = (
//     points: number[],
//     options?: {
//       step?: number;
//       maxPoints?: number;
//     }
//   ) => {
//     const step = options?.step || 4;
//     const maxPoints = options?.maxPoints || 80;
//     if (!points || points.length < 2) return [];
//     const result: number[] = [];
//     for (let i = 0; i < points.length; i += step * 2) {
//       result.push(points[i], points[i + 1]);
//     }
//     if (result.length > maxPoints * 2) {
//       return result.slice(result.length - maxPoints * 2);
//     }
//     return result;
//   };

//   const TrajectoryDots = React.memo(({ track, isPlaying }: any) => {
//     const color = CLASS_COLORS[track.class] || CLASS_COLORS.default;
//     const optimizedPoints = React.useMemo(() => {
//       return optimizeTrajectoryPoints(track.points, {
//         step: isPlaying ? 6 : 3,
//         maxPoints: isPlaying ? 50 : 100,
//       });
//     }, [track.points, isPlaying]);
//     if (optimizedPoints.length < 2) return null;

//     return (
//       <>
//         {optimizedPoints.map((_, i) => {
//           if (i % 2 !== 0) return null;
//           const x = optimizedPoints[i];
//           const y = optimizedPoints[i + 1];
//           return (
//             <Circle
//               key={`${track.id}-${i}`}
//               x={x}
//               y={y}
//               radius={isPlaying ? 2 : 1.3}
//               fill={color}
//               opacity={isPlaying ? 0.7 : 1}
//               listening={false}
//             />
//           );
//         })}
//       </>
//     );
//   });

//   const AISwitch = styled(Switch)(() => ({
//     width: 34,
//     height: 18,
//     padding: 0,
//     "& .MuiSwitch-switchBase": {
//       padding: 2,
//       "&.Mui-checked": {
//         transform: "translateX(14px)",
//         color: "#fff",
//         "& + .MuiSwitch-track": {
//           background: "linear-gradient(135deg, #6a00ff, #3b00ff)",
//           opacity: 1,
//         },
//       },
//     },
//     "& .MuiSwitch-thumb": {
//       width: 14,
//       height: 14,
//       backgroundColor: "#fff",
//     },
//     "& .MuiSwitch-track": {
//       borderRadius: 20,
//       backgroundColor: "#333",
//       opacity: 1,
//     },
//   }));

//   const getTotalCount = (name: string) => {
//     const counts = zoneData?.class_counts_by_region?.[name];
//     if (!counts) return "0";
//     const total = Object.values(counts).reduce(
//       (sum: number, value: any) => sum + Number(value),
//       0
//     );
//     return total.toLocaleString();
//   };

//   // ==================== RENDER ====================
//   const getExportDataInExcel = async () => {
//     setExportLoading(true);
//     const selectedDeviceDate = formatDateTimeRange(selectedDate);
//     const tunnelUrl = activeCarDetails?.raw?.tunnel_info?.[0];
//     try {
//       const payload = {
//         statDate:
//           selectedDeviceDate?.start_datetime?.replace(" ", "T") + ":00",
//         endDate:
//           selectedDeviceDate?.end_datetime?.replace(" ", "T") + ":59",
//         deviceId: activeCarDetails?.raw?.uuid,
//         exportType: selectedExportType,
//         tunnelUrl: tunnelUrl,
//       };
//       const res: any =
//         selectedExportType === "PETData" ||
//           selectedExportType === "TTCData"
//           ? await getExportDataTtcPet(payload)
//           : await getExportData(payload);
//       if (!res) {
//         showToast("Something went wrong", "e");
//         return;
//       }
//       const csvData = res?.data || res;
//       const blob = new Blob([csvData], {
//         type: "text/csv;charset=utf-8;",
//       });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute(
//         "download",
//         `${selectedExportType.replace(/\s+/g, "_")}_${Date.now()}.csv`
//       );
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//       setOpenExportModal(false);
//     } catch (error) {
//       console.error("Export API Error:", error);
//       showToast("Export failed", "e");
//     } finally {
//       setExportLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!videoSegments?.length) return;
//     const firstSegment = videoSegments?.[0]?.[0];
//     if (!firstSegment) return;
//     setCurrentTime(firstSegment.start);
//     updateVideoSources(firstSegment.start);
//   }, [videoSegments]);

//   useEffect(() => {
//     if (
//       features?.lineZone &&
//       rawApiLines?.items?.length > 0
//     ) {
//       const cameraKey = "video-0";
//       const container = videoContainerRefs.current[cameraKey];
//       const player = playerRefs.current[cameraKey];
//       const video = player?.getInternalPlayer() as HTMLVideoElement;
//       if (container && video) {
//         updateScale(container, video);
//       }
//       setCanvasSize(prev => ({
//         ...prev
//       }));
//     }
//   }, [
//     rawApiLines,
//     features?.lineZone,
//     updateScale
//   ]);

//   const zoneCounts = React.useMemo(() => {
//     const ttcCounts: Record<string, number> = {};
//     const petCounts: Record<string, number> = {};
//     // TTC
//     (ttcCountData?.events || []).forEach((e: any) => {
//       ttcCounts[e.Direction] = (ttcCounts[e.Direction] || 0) + 1;
//     });
//     // PET
//     (petCountData?.events || []).forEach((e: any) => {
//       petCounts[e.Direction] = (petCounts[e.Direction] || 0) + 1;
//     });
//     return { ttcCounts, petCounts };
//   }, [ttcCountData, petCountData]);


//   return (
//     <Row>
//       {activeIndex === 1 && (
//         <div
//           onClick={onClickPlayBack}
//           style={{
//             position: 'absolute', zIndex: 1, gap: 4, margin: "5px 20px", padding: 5,
//             backgroundColor: colors.modalBackground, color: colors.white, fontWeight: 'bold',
//             border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex',
//             alignItems: 'center', width: "120px"
//           }}
//         >
//           <ArrowBack style={{ marginLeft: 5, color: colors.orange }} />
//           Playback
//         </div>
//       )}
//       {videoSegments?.length > 0 ? (
//         <Col xs={12} style={{ padding: "0px" }}>
//           <div ref={containerRef} className="video-player-container">
//             <div ref={videoSectionRef} className={`video-grid ${isSingle ? 'single' : ''} ${isOdd ? 'odd' : 'even'}`}>
//               {cameraOrder?.map((index: any, displayIndex: any) => {
//                 const cameraKey = `video-${index}`;
//                 if (selectedCamera !== null && selectedCamera !== index) return null;
//                 const segment = findVideoSegment(currentTime, index);
//                 return (
//                   <div
//                     key={cameraKey}
//                     ref={el => (videoContainerRefs.current[cameraKey] = el)}
//                     className="video-wrapper"
//                     style={{ position: 'relative' }}
//                   >
//                     {segment && !isSDCard ? (
//                       <>
//                         <div
//                           className="player-container"
//                           onMouseEnter={() => setIsHovered(true)}
//                           onMouseLeave={() => setIsHovered(false)}
//                           style={{ marginTop: "-17px", background: "#333", cursor: "pointer" }}
//                           onClick={togglePlayPause}
//                         >
//                           <ReactPlayer
//                             ref={(el) => (playerRefs.current[cameraKey] = el)}
//                             url={videoUrls[cameraKey]}
//                             playing={isPlaying}
//                             playbackRate={playbackRate}
//                             muted={displayIndex !== cameraOrder.length - 1 || muted}
//                             width="100%"
//                             height="100%"
//                             controls={false}
//                             playsinline
//                             config={{
//                               file: {
//                                 forceHLS: true,
//                                 hlsOptions: {
//                                   enableWorker: true,
//                                   lowLatencyMode: false,
//                                   maxBufferLength: 300,
//                                   maxMaxBufferLength: 600,
//                                   backBufferLength: 120,
//                                   maxBufferSize: 60 * 1000 * 1000, // 60MB
//                                 }
//                               },
//                             }}
//                             onBuffer={() => {
//                               bufferTimeouts.current[cameraKey] = setTimeout(() => {
//                                 setVideoLoading(prev => ({
//                                   ...prev,
//                                   [cameraKey]: true,
//                                 }));
//                               }, 1500);
//                             }}

//                             onBufferEnd={() => {
//                               const timeout = bufferTimeouts.current[cameraKey];
//                               if (timeout) {
//                                 clearTimeout(timeout);
//                               }
//                               setVideoLoading(prev => ({
//                                 ...prev,
//                                 [cameraKey]: false,
//                               }));
//                             }}
//                             onError={(e) => {
//                               console.error("Video Error", cameraKey, e);
//                             }}
//                             onProgress={({ playedSeconds }) => {
//                               const segment = findVideoSegment(currentTime, index);
//                               if (!segment) return;
//                               const duration = segment.end - segment.start;
//                               if (duration - playedSeconds < 5) {
//                                 const segments = videoSegments[index] || [];
//                                 const currentSegmentIndex = segments.findIndex(
//                                   s => s.specific_file_url === segment.specific_file_url
//                                 );
//                                 const nextSegment = segments[currentSegmentIndex + 1];
//                                 if (nextSegment) {
//                                   prefetchSegment(nextSegment.specific_file_url);
//                                 }
//                               }
//                             }}
//                           />
//                           <img
//                             src="/watermark.png"
//                             alt="watermark"
//                             style={{
//                               position: 'absolute', bottom: '10px', right: '10px',
//                               width: '150px', opacity: 0.7, zIndex: 999, pointerEvents: 'none',
//                             }}
//                           />
//                           <Stage
//                             width={canvasSize.width}
//                             height={canvasSize.height}
//                             style={{ position: "absolute", top: 0, left: 0, pointerEvents: isDrawingMode ? "auto" : "none" }}
//                             ref={stageRef}
//                             onMouseDown={(e: any) => {
//                               if (!drawingMode) return;
//                               if (drawingMode === "line" && lines.length >= 1) return;
//                               if (drawingMode === "zone" && lines.length >= 2) return;
//                               const pos = e.target.getStage().getPointerPosition();
//                               if (!pos) return;
//                               setCurrentLine([pos.x, pos.y]);
//                               setIsDrawing(true);
//                             }}
//                             onMouseMove={(e: any) => {
//                               if (!isDrawing || !drawingMode) return;
//                               const pos = e.target.getStage().getPointerPosition();
//                               if (!pos) return;
//                               setCurrentLine(prev => [prev[0], prev[1], pos.x, pos.y]);
//                             }}
//                             onMouseUp={() => {
//                               if (!drawingMode) return;
//                               setIsDrawing(false);
//                               if (currentLine.length === 4) {
//                                 setLines(prev => [...prev, currentLine]);
//                               }
//                               setCurrentLine([]);
//                             }}
//                           >
//                             <Layer>
//                               {!isPlaying && (
//                                 <>
//                                   {features?.trajectory && (
//                                     <>
//                                       {processedTrajectories?.map((track) => (
//                                         <TrajectoryDots
//                                           key={track.id}
//                                           track={track}
//                                           isPlaying={isPlaying}
//                                         />
//                                       ))}
//                                     </>
//                                   )}
//                                 </>
//                               )}

//                               {tracks?.map(track =>
//                                 track.points.length > 4 ? (
//                                   <Line
//                                     key={`track-${track.id}`}
//                                     points={track.points}
//                                     stroke="#58e6b3"
//                                     strokeWidth={2}
//                                     tension={0.4}
//                                     lineCap="round"
//                                     lineJoin="round"
//                                   />
//                                 ) : null
//                               )}

//                               {lines?.map((line, i) => (
//                                 <Line key={`draw-${i}`} points={line} stroke="yellow" strokeWidth={3} />
//                               ))}

//                               {/* {features?.ttc && (
//                                 <>
//                                   {ttcPetLineData?.items?.map((item: any, i: number) => {
//                                     const sourceWidth = 1920;
//                                     const sourceHeight = 1080;
//                                     const scaleX = canvasSize.width / sourceWidth;
//                                     const scaleY = canvasSize.height / sourceHeight;
//                                     const l1x1 = item.l1x1 * scaleX;
//                                     const l1y1 = item.l1y1 * scaleY;
//                                     const l1x2 = item.l1x2 * scaleX;
//                                     const l1y2 = item.l1y2 * scaleY;
//                                     const l2x1 = item.l2x1 * scaleX;
//                                     const l2y1 = item.l2y1 * scaleY;
//                                     const l2x2 = item.l2x2 * scaleX;
//                                     const l2y2 = item.l2y2 * scaleY;
//                                     const polygonPoints = [
//                                       l1x1,
//                                       l1y1,
//                                       l1x2,
//                                       l1y2,
//                                       l2x2,
//                                       l2y2,
//                                       l2x1,
//                                       l2y1,
//                                     ];
//                                     const centerX =
//                                       (l1x1 + l1x2 + l2x1 + l2x2) / 4;
//                                     const centerY =
//                                       (l1y1 + l1y2 + l2y1 + l2y2) / 4;
//                                     return (
//                                       <React.Fragment key={`ttc-zone-${i}`}>
//                                         <Line
//                                           points={polygonPoints}
//                                           closed
//                                           fill="rgba(255,0,0,0.15)"
//                                           stroke="#ff0000"
//                                           strokeWidth={3}
//                                         />
//                                         <Text
//                                           text={item.region_name}
//                                           x={centerX - 60}
//                                           y={centerY - 10}
//                                           width={120}
//                                           align="center"
//                                           fontSize={16}
//                                           fill="#ff0000"
//                                           fontStyle="bold"
//                                         />
//                                         <Text
//                                           text={`TTC Count : ${ttcCountData ?? 0}`}
//                                           x={20}
//                                           y={20}
//                                           fontSize={15}
//                                           fill="#00ff00"
//                                           fontStyle="bold"
//                                         />
//                                       </React.Fragment>
//                                     );
//                                   })}
//                                   {ttcPetLineData?.lane_boundaries?.map(
//                                     (lane: any, i: number) => {
//                                       const sourceWidth = 1920;
//                                       const sourceHeight = 1080;
//                                       const scaleX = canvasSize.width / sourceWidth;
//                                       const scaleY = canvasSize.height / sourceHeight;
//                                       const x1 = lane.pt1[0] * scaleX;
//                                       const y1 = lane.pt1[1] * scaleY;
//                                       const x2 = lane.pt2[0] * scaleX;
//                                       const y2 = lane.pt2[1] * scaleY;
//                                       return (
//                                         <>
//                                           <Line
//                                             key={`ttc-lane-${i}`}
//                                             points={[x1, y1, x2, y2]}
//                                             stroke="#FFA500"
//                                             strokeWidth={3}
//                                           />

//                                           <Text
//                                             text={`PET Count : ${petCountData?.total ?? 0}`}
//                                             x={20}
//                                             y={55}
//                                             fontSize={15}
//                                             fill="#ff9800"
//                                             fontStyle="bold"
//                                           />
//                                         </>
//                                       );
//                                     }
//                                   )}
//                                 </>
//                               )} */}

//                               {features?.ttc && (
//                                 <>
//                                   {ttcPetLineData?.items?.map((item: any, i: number) => {
//                                     const sourceWidth = 1920;
//                                     const sourceHeight = 1080;
//                                     const scaleX = canvasSize.width / sourceWidth;
//                                     const scaleY = canvasSize.height / sourceHeight;

//                                     const l1x1 = item.l1x1 * scaleX;
//                                     const l1y1 = item.l1y1 * scaleY;
//                                     const l1x2 = item.l1x2 * scaleX;
//                                     const l1y2 = item.l1y2 * scaleY;
//                                     const l2x1 = item.l2x1 * scaleX;
//                                     const l2y1 = item.l2y1 * scaleY;
//                                     const l2x2 = item.l2x2 * scaleX;
//                                     const l2y2 = item.l2y2 * scaleY;

//                                     const polygonPoints = [l1x1, l1y1, l1x2, l1y2, l2x2, l2y2, l2x1, l2y1];
//                                     const centerX = (l1x1 + l1x2 + l2x1 + l2x2) / 4;
//                                     const centerY = (l1y1 + l1y2 + l2y1 + l2y2) / 4;

//                                     const ttcCount = zoneCounts.ttcCounts[item.region_name] ?? 0;
//                                     const petCount = zoneCounts.petCounts[item.region_name] ?? 0;

//                                     return (
//                                       <React.Fragment key={`ttc-zone-${i}`}>
//                                         <Line
//                                           points={polygonPoints}
//                                           closed
//                                           fill="rgba(255,0,0,0.15)"
//                                           stroke="#ff0000"
//                                           strokeWidth={3}
//                                         />
//                                         <Text
//                                           text={item.region_name}
//                                           x={centerX - 60}
//                                           y={centerY - 10}
//                                           width={120}
//                                           align="center"
//                                           fontSize={16}
//                                           fill="#ff0000"
//                                           fontStyle="bold"
//                                         />
//                                         <Text
//                                           text={`TTC Count : ${ttcCount}`}
//                                           x={centerX - 60}
//                                           y={centerY + 10}
//                                           width={150}
//                                           align="center"
//                                           fontSize={15}
//                                           fill="#00ff00"
//                                           fontStyle="bold"
//                                         />
//                                         <Text
//                                           text={`PET Count : ${petCount}`}
//                                           x={centerX - 60}
//                                           y={centerY + 28}
//                                           width={180}
//                                           align="center"
//                                           fontSize={15}
//                                           fill="#ff9800"
//                                           fontStyle="bold"
//                                         />
//                                       </React.Fragment>
//                                     );
//                                   })}

//                                   {ttcPetLineData?.lane_boundaries?.map((lane: any, i: number) => {
//                                     const sourceWidth = 1920;
//                                     const sourceHeight = 1080;
//                                     const scaleX = canvasSize.width / sourceWidth;
//                                     const scaleY = canvasSize.height / sourceHeight;

//                                     const x1 = lane.pt1[0] * scaleX;
//                                     const y1 = lane.pt1[1] * scaleY;
//                                     const x2 = lane.pt2[0] * scaleX;
//                                     const y2 = lane.pt2[1] * scaleY;

//                                     return (
//                                       <Line
//                                         key={`ttc-lane-${i}`}
//                                         points={[x1, y1, x2, y2]}
//                                         stroke="#FFA500"
//                                         strokeWidth={3}
//                                       />
//                                     );
//                                   })}
//                                 </>
//                               )}


//                               {features?.lineZone && rawApiLines?.items?.length > 0 && (
//                                 <>
//                                   {rawApiLines?.items?.map((item: any, i: number) => {
//                                     const { renderW, renderH, offsetX, offsetY } = displayScale;
//                                     const sourceWidth = item.sourceWidth || 1920;
//                                     const sourceHeight = item.sourceHeight || 1080;
//                                     if (item.type === "line") {
//                                       const x1 =
//                                         (item.lx1 / sourceWidth) * renderW +
//                                         offsetX;

//                                       const y1 =
//                                         (item.ly1 / sourceHeight) * renderH +
//                                         offsetY;

//                                       const x2 =
//                                         (item.lx2 / sourceWidth) * renderW +
//                                         offsetX;

//                                       const y2 =
//                                         (item.ly2 / sourceHeight) * renderH +
//                                         offsetY;
//                                       const centerX = (x1 + x2) / 2;
//                                       const centerY = (y1 + y2) / 2;
//                                       const angle = (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI;
//                                       return (
//                                         <React.Fragment key={`line-${i}`}>
//                                           <Line
//                                             points={[x1, y1, x2, y2]}
//                                             stroke="#0566FD80"
//                                             strokeWidth={18}
//                                           //lineCap="round"
//                                           //lineJoin="round"
//                                           />
//                                           <Group
//                                             x={centerX}
//                                             y={centerY}
//                                             rotation={angle}
//                                           >
//                                             <Text
//                                               text={`${item.line_name} : ${getTotalCount(
//                                                 item.line_name
//                                               )}`}
//                                               fontSize={14}
//                                               fill="#ffffff"
//                                               width={180}
//                                               align="center"
//                                               offsetX={80}
//                                               offsetY={8}
//                                               fontStyle="bold"
//                                               shadowColor="black"
//                                               shadowBlur={4}
//                                               shadowOpacity={0.8}
//                                               shadowOffset={{ x: 1, y: 1 }}
//                                             />
//                                           </Group>
//                                         </React.Fragment>
//                                       );
//                                     }
//                                     if (item.type === "zone_occupancy") {
//                                       const sourceWidth = item.sourceWidth || 1920;
//                                       const sourceHeight = item.sourceHeight || 1080;

//                                       const l1x1 =
//                                         (item.l1x1 / sourceWidth) * renderW +
//                                         offsetX;

//                                       const l1y1 =
//                                         (item.l1y1 / sourceHeight) * renderH +
//                                         offsetY;

//                                       const l1x2 =
//                                         (item.l1x2 / sourceWidth) * renderW +
//                                         offsetX;

//                                       const l1y2 =
//                                         (item.l1y2 / sourceHeight) * renderH +
//                                         offsetY;

//                                       const l2x1 =
//                                         (item.l2x1 / sourceWidth) * renderW +
//                                         offsetX;

//                                       const l2y1 =
//                                         (item.l2y1 / sourceHeight) * renderH +
//                                         offsetY;

//                                       const l2x2 =
//                                         (item.l2x2 / sourceWidth) * renderW +
//                                         offsetX;

//                                       const l2y2 =
//                                         (item.l2y2 / sourceHeight) * renderH +
//                                         offsetY;
//                                       const polygonPoints = [
//                                         l1x1,
//                                         l1y1,
//                                         l1x2,
//                                         l1y2,
//                                         l2x2,
//                                         l2y2,
//                                         l2x1,
//                                         l2y1,
//                                       ];
//                                       const centerX = (l1x1 + l1x2 + l2x1 + l2x2) / 4;
//                                       const centerY = (l1y1 + l1y2 + l2y1 + l2y2) / 4;
//                                       const angle = (Math.atan2(l1y2 - l1y1, l1x2 - l1x1) * 180) / Math.PI;
//                                       return (
//                                         <React.Fragment key={`region-${i}`}>
//                                           <Line
//                                             points={polygonPoints}
//                                             closed
//                                             fill="rgba(5,102,253,0.18)"
//                                             stroke="#0566FD"
//                                             strokeWidth={2}
//                                           />
//                                           <Group
//                                             x={centerX}
//                                             y={centerY}
//                                             rotation={angle}
//                                           >
//                                             <Text
//                                               text={`${item.region_name} : ${getTotalCount(
//                                                 item.region_name
//                                               )}`}
//                                               fontSize={16}
//                                               fill="#ffffff"
//                                               width={180}
//                                               align="center"
//                                               offsetX={90}
//                                               offsetY={8}
//                                               fontStyle="bold"
//                                               shadowColor="black"
//                                               shadowBlur={4}
//                                               shadowOpacity={0.8}
//                                               shadowOffset={{ x: 1, y: 1 }}
//                                             />
//                                           </Group>
//                                         </React.Fragment>
//                                       );
//                                     }
//                                     return null;
//                                   })}
//                                 </>
//                               )}

//                               {currentLine?.length === 4 && (
//                                 <Line points={currentLine} stroke="red" strokeWidth={3} dash={[5, 5]} />
//                               )}

//                               {objects?.map(obj => {
//                                 const labelWidth = getLabelWidth(obj.label);
//                                 const labelY = obj.centerY - 30;
//                                 return (
//                                   <React.Fragment key={`obj-${obj.id}`}>
//                                     <Line
//                                       points={[obj.centerX, obj.centerY, obj.centerX, labelY + 20]}
//                                       stroke="#58e6b3"
//                                       strokeWidth={2}
//                                     />
//                                     <Rect
//                                       x={obj.x} y={obj.y}
//                                       width={obj.width} height={obj.height}
//                                       stroke="yellow" strokeWidth={1}
//                                     />
//                                     <Text
//                                       x={obj.centerX - labelWidth / 2 + 6}
//                                       y={labelY + 5}
//                                       text={String(obj.id)}
//                                       fill="yellow"
//                                       fontSize={16}
//                                     />
//                                   </React.Fragment>
//                                 );
//                               })}
//                             </Layer>
//                           </Stage>
//                           {showDistanceInput && (
//                             <div style={{ position: "absolute", top: 100, right: 10, background: "white", padding: 3, zIndex: 1000, borderRadius: 6 }}>
//                               <input
//                                 type="text"
//                                 placeholder="Enter Line/Zone Name"
//                                 value={lineName}
//                                 onChange={(e) => setLineName(e.target.value)}
//                                 style={{ marginBottom: "0px", border: "1px solid #333", color: "#333", borderRadius: "10px", fontSize: "12px", padding: "0px 10px" }}
//                               />
//                               <br />
//                               <input
//                                 type="number"
//                                 placeholder="Enter distance"
//                                 value={distance}
//                                 onChange={(e) => setDistance(e.target.value)}
//                                 style={{ marginBottom: "0px", border: "1px solid #333", color: "#333", borderRadius: "10px", fontSize: "12px", padding: "0px 10px" }}
//                               />
//                               <br />
//                               <center>
//                                 <button
//                                   onClick={() => {
//                                     if (!drawingMode) {
//                                       alert("Select mode first");
//                                       return;
//                                     }
//                                     if (drawingMode === "line" && lines.length !== 1) {
//                                       alert("Draw exactly 1 line");
//                                       return;
//                                     }
//                                     if (drawingMode === "zone" && lines.length !== 2) {
//                                       alert("Draw exactly 2 lines for zone");
//                                       return;
//                                     }
//                                     if (!distance) {
//                                       alert("Enter distance");
//                                       return;
//                                     }
//                                     let newItem;
//                                     if (drawingMode === "line") {
//                                       newItem = createLinePayload(lines[0], Number(distance));
//                                     }
//                                     if (drawingMode === "zone") {
//                                       newItem = createZonePayload(lines, Number(distance));
//                                     }
//                                     const finalPayload = {
//                                       items: [...previousApiLinesData, newItem],
//                                       default_distance_m: Number(distance),
//                                     };
//                                     // console.log("payload====>", finalPayload);
//                                     fetch(activeCarDetails?.raw?.tunnel_info?.[0] + "/save-lines", {
//                                       method: "POST",
//                                       headers: { "Content-Type": "application/json" },
//                                       body: JSON.stringify(finalPayload),
//                                     });
//                                     //getVideoLineDetails();
//                                     setShowDistanceInput(false);
//                                     setDistance("");
//                                     setLines([]);
//                                     setCurrentLine([]);
//                                     setDrawingMode(null);
//                                   }}
//                                   className="mainButton"
//                                   style={{ borderRadius: "10px", margin: "3px 0px 0px 1px" }}
//                                 >
//                                   Submit
//                                 </button>
//                               </center>
//                             </div>
//                           )}
//                           {videoLoading[cameraKey] && (
//                             <div className="loader-overlay"><div className="loader"></div></div>
//                           )}
//                           {videoErrors[cameraKey] && (
//                             <div className="error-overlay">{videoErrors[cameraKey]}</div>
//                           )}
//                         </div>
//                         {isHovered && videoSegments?.length >= 3 && (
//                           <button
//                             onClick={() => handlePinClick(index)}
//                             style={{
//                               zIndex: 1000, position: 'absolute', top: '50%', left: '50%',
//                               borderRadius: '10px', padding: '5px 10px',
//                               cursor: cameraOrder.length > 1 ? 'pointer' : 'not-allowed', color: 'red',
//                             }}
//                             disabled={cameraOrder.length <= 1}
//                           >
//                             <PushPinIcon style={{ color: 'white', fontSize: 24 }} />
//                           </button>
//                         )}
//                         {displayIndex !== cameraOrder.length - 1 ? null : (
//                           <div style={{ marginLeft: dynamicMarginLeft, display: 'flex', gap: '18px', zIndex: 999, padding: '3px 0px 0px 0px', borderRadius: '5px', marginTop: "0px" }}>
//                             <div
//                               style={{
//                                 position: "absolute",
//                                 top: "22px",
//                                 right: "15px",
//                                 zIndex: 999,
//                                 pointerEvents: "auto",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "3px",
//                                 background: "rgba(0,0,0,0.5)",
//                                 padding: "6px 10px",
//                                 borderRadius: "20px",
//                                 backdropFilter: "blur(6px)",
//                               }}
//                               onClick={(e) => e.stopPropagation()}
//                             >
//                               <SmartToyIcon
//                                 style={{
//                                   color: "#fff",
//                                   fontSize: "18px",
//                                   pointerEvents: "none",
//                                 }}
//                               />
//                               <span
//                                 style={{
//                                   color: "#fff",
//                                   fontSize: "13px",
//                                   pointerEvents: "none",
//                                 }}
//                               >
//                                 AI Mode
//                               </span>
//                               <AISwitch
//                                 checked={aiMode}
//                                 onClick={(e) => e.stopPropagation()}
//                                 onChange={(e) => {
//                                   e.stopPropagation();
//                                   setAiMode(e.target.checked);
//                                 }}
//                               />
//                             </div>

//                             {aiMode && (
//                               <div
//                                 style={{
//                                   position: "absolute",
//                                   top: "60px",
//                                   right: "10px",
//                                   width: "200px",
//                                   background: "rgba(0,0,0,0.7)",
//                                   backdropFilter: "blur(12px)",
//                                   borderRadius: "12px",
//                                   padding: "5px",
//                                   border: "1px solid rgba(255,255,255,0.1)",
//                                   color: "#fff",
//                                   zIndex: 1000,
//                                   fontSize: "12px",
//                                 }}
//                               >
//                                 <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
//                                   AI Features
//                                 </div>

//                                 <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//                                   {[
//                                     { key: "ttc", label: "TTC/PET Line" },
//                                     // { key: "trajectory", label: "Trajectory" },
//                                     { key: "lineZone", label: "Line & Zone" },
//                                   ].map((item) => (
//                                     <label
//                                       key={item.key}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "6px 10px",
//                                         borderRadius: "8px",
//                                         border: "1px solid rgba(255,255,255,0.15)",
//                                         cursor: "pointer",
//                                       }}
//                                     >
//                                       <span>{item.label}</span>

//                                       <input
//                                         type="checkbox"
//                                         checked={features[item.key as FeatureKey]}
//                                         onChange={() => toggleFeature(item.key as FeatureKey)}
//                                       />
//                                     </label>
//                                   ))}
//                                 </div>
//                               </div>
//                             )}

//                             <button style={{ color: "#333" }} onClick={() => setOpenExportModal(true)}>
//                               <FileUploadIcon fontSize="small" titleAccess="Export data in excel" />
//                             </button>

//                             <Dialog
//                               open={openExportModal}
//                               onClose={() => !exportLoading && setOpenExportModal(false)}
//                               maxWidth="xs"
//                               fullWidth
//                             >
//                               <DialogTitle
//                                 style={{
//                                   fontWeight: 600,
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 Select Export Type
//                               </DialogTitle>

//                               {exportLoading ? (
//                                 <div
//                                   style={{
//                                     padding: "40px 20px",
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "center",
//                                     alignItems: "center",
//                                     gap: "12px",
//                                   }}
//                                 >
//                                   <CircularProgress size={35} />

//                                   <p
//                                     style={{
//                                       margin: 0,
//                                       fontSize: "14px",
//                                       color: "#666",
//                                     }}
//                                   >
//                                     Exporting data...
//                                   </p>
//                                 </div>
//                               ) : (
//                                 <>
//                                   <DialogContent>
//                                     <RadioGroup
//                                       value={selectedExportType}
//                                       onChange={(e) => setSelectedExportType(e.target.value)}
//                                     >
//                                       <FormControlLabel
//                                         value="AIData"
//                                         control={<Radio />}
//                                         label="AI Data"
//                                       />

//                                       <FormControlLabel
//                                         value="TTCData"
//                                         control={<Radio />}
//                                         label="TTC Data"
//                                       />

//                                       <FormControlLabel
//                                         value="PETData"
//                                         control={<Radio />}
//                                         label="PET Data"
//                                       />
//                                     </RadioGroup>
//                                   </DialogContent>

//                                   <DialogActions style={{ padding: "16px" }}>
//                                     <Button
//                                       onClick={() => setOpenExportModal(false)}
//                                       variant="outlined"
//                                       color="inherit"
//                                     >
//                                       Cancel
//                                     </Button>

//                                     <Button
//                                       onClick={getExportDataInExcel}
//                                       variant="contained"
//                                       style={{
//                                         background: "#ff7a00",
//                                         color: "#fff",
//                                       }}
//                                     >
//                                       Export
//                                     </Button>
//                                   </DialogActions>
//                                 </>
//                               )}
//                             </Dialog>

//                             {/* <button style={{ color: "#333" }} onClick={() => setShowVideoChart(prev => !prev)}>
//                               <AssessmentIcon titleAccess="Show Video Chart" />
//                             </button> */}
//                             <button onClick={fiveSecBack} style={{ background: 'none', border: 'none', color: '#000', cursor: 'pointer' }}>
//                               <ClockFiveIcon title="Rewind 5 Seconds" />
//                             </button>
//                             <button onClick={() => setShowSpeedOptions(!showSpeedOptions)} style={{ background: 'none', border: 'none', color: '#000', cursor: 'pointer' }}>
//                               <p style={{ margin: "0px", fontWeight: "bold", fontSize: "13px" }} title="Set Video Playback Speed">
//                                 {playbackRate}X
//                               </p>
//                             </button>
//                             <button
//                               onClick={togglePlayPause}
//                               disabled={isJumping}
//                               style={{ background: 'none', color: '#000', cursor: 'pointer', border: "2px solid #ff7a00", borderRadius: "50%", width: "27px", height: "26px" }}
//                             >
//                               {isPlaying
//                                 ? <PauseIcon style={{ fontSize: "25px", marginTop: "-6px" }} titleAccess="Pause Video" />
//                                 : <PlayArrowIcon style={{ fontSize: "25px", marginTop: "-6px" }} titleAccess="Play Video" />
//                               }
//                             </button>
//                             <button onClick={fiveSecForward} style={{ background: 'none', border: 'none', color: '#000', cursor: 'pointer' }}>
//                               <RefreshCircleIcon title="Forward 5 Seconds" />
//                             </button>
//                             {showSpeedOptions && (
//                               <div style={{ position: 'absolute', bottom: '50px', left: '10px', background: 'rgba(0,0,0,0.7)', padding: '8px', borderRadius: '5px', display: 'flex', gap: '10px', zIndex: 1000 }}>
//                                 {videoPlaySec?.map(speed => (
//                                   <button
//                                     key={speed}
//                                     onClick={() => { setPlaybackRate(speed); setShowSpeedOptions(false); }}
//                                     style={{ background: playbackRate === speed ? 'white' : 'transparent', color: playbackRate === speed ? 'black' : 'white', border: 'none', borderRadius: '3px', padding: '5px 8px', cursor: 'pointer' }}
//                                     title={`Set video playback speed to ${speed}x`}
//                                   >
//                                     {speed}x
//                                   </button>
//                                 ))}
//                               </div>
//                             )}
//                             <button style={{ color: "#333" }}>
//                               <AccessTimeIcon onClick={() => setShowTimeOptions(!showTimeOptions)} titleAccess="Select Time Filters" />
//                             </button>
//                             {showTimeOptions && (
//                               <div style={{ position: 'absolute', bottom: '50px', left: '10px', background: 'rgba(0,0,0,0.85)', padding: '10px', borderRadius: '8px', display: 'flex', flexDirection: 'column', gap: '6px', zIndex: 1000, minWidth: '140px' }}>
//                                 <p style={{ color: 'white', margin: '0 0 4px 0', fontSize: '11px', opacity: 0.6 }}>Select time filters</p>
//                                 {videoLastData.map(value => {
//                                   const isSelected = activeTimeFilters.includes(value);
//                                   return (
//                                     <button
//                                       key={value}
//                                       onClick={() => setActiveTimeFilters(prev => isSelected ? prev.filter(f => f !== value) : [...prev, value])}
//                                       style={{ background: isSelected ? '#ff7a00' : 'transparent', color: 'white', border: '1px solid', borderColor: isSelected ? '#ff7a00' : 'rgba(255,255,255,0.3)', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer', textAlign: 'left', fontSize: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//                                     >
//                                       {value}
//                                       {isSelected && <span>✓</span>}
//                                     </button>
//                                   );
//                                 })}
//                                 {activeTimeFilters.length > 0 && (
//                                   <>
//                                     <button onClick={() => { setActiveTimeFilters([]); setShowTimeOptions(false); }} style={{ marginTop: '4px', background: 'red', color: 'white', border: 'none', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer', fontSize: '12px' }}>
//                                       Clear All
//                                     </button>
//                                     <button onClick={() => setActiveTimeFilters([])} style={{ background: 'none', border: '1px solid red', borderRadius: '4px', color: 'red', fontSize: '11px', fontWeight: 'bold', padding: '2px 6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '3px' }}>
//                                       {activeTimeFilters.length === 1 ? activeTimeFilters[0] : `${activeTimeFilters.length} filters`} ✕
//                                     </button>
//                                   </>
//                                 )}
//                               </div>
//                             )}
//                             <button
//                               onClick={toggleFullscreen}
//                               disabled={isJumping}
//                               style={{ background: 'none', border: 'none', color: '#000', cursor: 'pointer', marginLeft: view === 'Map' ? '95%' : '55%' }}
//                             >
//                               <RatioIcon title="Toggle Fullscreen Video" />
//                             </button>
//                           </div>
//                         )}
//                       </>
//                     ) : (
//                       <div className="no-video" style={{ textAlign: "center" }}>
//                         {displayIndex === cameraOrder.length - 1 && !isSDCard && (
//                           <div style={{ position: 'fixed', left: view === 'Map' ? '40%' : '47%', display: 'flex', gap: '18px', zIndex: 999, padding: '3px 0px 0px 0px', borderRadius: '5px', marginTop: "316px" }} />
//                         )}
//                         {isSDCard ? 'Video not available on server.' : 'No video available.'}
//                       </div>
//                     )}

//                     {(segment !== undefined && !isSDCard) && (
//                       <>
//                         <div style={{ position: 'absolute', left: videoSegments?.length === 2 ? '4%' : '2%', top: '13%', transform: 'translate(-50%, -50%)', zIndex: 10, background: "rgba(0,0,0,0.5)", borderRadius: "10px", lineHeight: "32px" }}>
//                           {/* <button>
//                             <CropFreeIcon titleAccess="Click To Full Screen" onClick={() => toggleSingleVideoFullscreen(index)} style={{ color: 'red' }} />
//                           </button> */}
//                           {/* <br /> */}
//                           <button>
//                             <AutorenewIcon titleAccess="Click To Rotate Video" onClick={() => handleRotateVideo(cameraKey)} style={{ color: 'red' }} />
//                           </button>
//                           <br />
//                           {!recordingState[cameraKey] && !recordedUrls[cameraKey] && (
//                             <button onClick={() => startRecording(cameraKey)}>
//                               <FiberManualRecordIcon style={{ color: 'red' }} titleAccess="Click To Start Recording" />
//                             </button>
//                           )}
//                           {recordingState[cameraKey] && (
//                             <button onClick={() => stopRecording(cameraKey)}>
//                               <StopIcon titleAccess="Click To Stop Recording" />
//                             </button>
//                           )}
//                           {recordedUrls[cameraKey] && (
//                             <a href={recordedUrls[cameraKey]!} download={`recording-${cameraKey}.webm`}>
//                               <button>
//                                 <CloudDownloadIcon titleAccess="Click To Download Recorded Video" style={{ color: "#fff" }} />
//                               </button>
//                             </a>
//                           )}
//                         </div>
//                         {recordingState[cameraKey] && (
//                           <div style={{ color: 'red', fontWeight: 'bold', zIndex: 999, position: "absolute", padding: "0px 20px" }}>
//                             Recording: {formatTime(recordingTimes[cameraKey] || 0)}
//                           </div>
//                         )}
//                       </>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>

//             {showVideoChart && (
//               <div style={{ position: 'absolute', bottom: '104px', left: "-21px", right: 2, zIndex: 9999, padding: '0 10px' }}>
//                 <VideoChart value={currentTime} segments={filteredVideoSegments} />
//               </div>
//             )}

//             <div className="timeline-wrapper" style={{ marginTop: "15px" }}>
//               <ProgressScale
//                 key={`${videoSegments}`}
//                 value={currentTime}
//                 segments={filteredVideoSegments}
//                 onChange={handleTimelineChange}
//                 bufferedUntil={bufferedUntil}
//               />
//             </div>
//             <div className="stepper-wrapper">

//             </div>
//           </div>
//         </Col>
//       ) : (
//         <div style={{ width: '100%', height: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'relative', overflow: 'visible', background: "#333" }}>
//           <div>Playback video not found</div>
//         </div>
//       )
//       }
//     </Row >
//   );
// };

// export default React.memo(MultiVideoPlayerCctv);